﻿/// <reference path="../../typings/jquery/index.d.ts" />
/// <reference path="../../typings/history.d.ts" />
/// <reference path="../../typings/jqueryui.d.ts" />
/// <reference path="../../typings/jquery.validation.d.ts" />
/// <reference path="../../typings/express.d.ts" />
/// <reference path="../../typings/ga.d.ts" />
/// <reference path="../../typings/gapi.d.ts" />
/// <reference path="../../typings/gapi.auth2.d.ts" />
/// <reference path="../../typings/grecaptcha/index.d.ts" />
// @ts-ignore
const historyJs: Historyjs = <any>history;

declare let pageContext: any;
declare let isIE: boolean;

window.onunload = function () {
	// keep this. We need this function to prevent firefox caching this page.
};
window.onbeforeunload = function () {
	// keep this. We need this function to prevent IE11+ caching this page.
};

//@ts-ignore
$.ajaxPrefilter(function (opts, originalOpts: JQueryAjaxSettings & { retryCount?: number }, jqXHR) {
	//@ts-ignore
	if (opts.retryCount !== undefined && opts.retryCount === 0) {
		return;
	}

	// our own deferred object to handle done/fail callbacks
	const dfd = $.Deferred();

	// if the request works, return normally
	jqXHR.done(dfd.resolve);

	// if the request fails, do something else
	// yet still resolve
	jqXHR.fail(function (...args) {
		const { retryCount = 2 } = originalOpts;
		const canRetry = retryCount && (jqXHR.status === 0 || jqXHR.status === 404) && !jqXHR.getAllResponseHeaders(); // Mantis: 0028436  IE11: XMLHttpRequest: Network Error 0x2eff, Could not complete the operation due to error 00002eff
		if (canRetry) {
			// retry with a copied originalOpts with refreshRequest.
			const newOpts = $.extend({}, originalOpts, {
				retryCount: retryCount - 1
			});
			// pass this one on to our deferred pass or fail.
			$.ajax(newOpts).then(dfd.resolve, dfd.reject);

		} else {
			dfd.rejectWith(jqXHR, args);
		}
	});

	// NOW override the jqXHR's promise functions with our deferred
	return dfd.promise(jqXHR);
});

//fix for 0018855: neverending 'please wait' if you use browser back button from BE (saf-ipad only)
//@ts-ignore
if (history && history.pushState) {
	$(window).bind("popstate", function () {
		if (typeof window.HideLoadingDialog !== "undefined") {
			window.HideLoadingDialog();
		}
	});
}

/* tslint:disable:interface-name */
interface JQuery {
	lazyload: (args: any) => any;
	Jcrop: (args?: any) => any;
}

interface Event {
	touches: any;
}

/* tslint:disable:variable-name */
interface Window {
	CloseResponsiveDialog: (dialogId: string | undefined) => any;
	ShowLoadingDialog: (timeout?: number) => any;
	HideLoadingDialog: () => any;
	ShowActionDialog: (args: any) => any;
	PreventInvalidInput: (args: any, args1?: any, args2?: any) => any;
	ShowContentDialog: (args: any) => any;
	Cropper: () => any;
	dataLayerSite: any;
	dataLayer: any;
	initSlider: any;
	Cookiebot: any;
	pushDataLayer: (arg: object) => void;
	GetCookie: (args: any) => any;
	enableLeaveIntent: boolean;
	enableLeaveIntentConfigValue: boolean;
	DisableLeaveIntent(): void;
	EnableLeaveIntent(): void;
	LazyLoad: any;
	AdyenWeb: any;
	context: any;
	gtmData: string;
}

namespace eXpress.core {
	export declare let context: IAppContext;

	// types

	export type PartnerType = "express" | "facebook" | "googlephotos" | "instagram";

	export const emptyGuid = '00000000-0000-0000-0000-000000000000';

	// enums

	export enum StoreType {
		eXpress = 0,
		GooglePhotos = 2,
		Facebook = 3,
		Instagram = 4,
		SwissCom = 5,
		Local = 10
	}

	// interfaces

	export interface IAppContext {
		apiHostUrl: string;
		pointOfSaleId: string;
		languageCode: string;
		cdn: string;
		contentRevision: string;
		productRevision: string;
		accountType: string;
		regionCode: string;
		regionTwoLetterCode: string;
		applicationId: string;
		mobileTransitionScreenWidth: number;
		allowMobile: boolean;
		ecomApiUrl: string;
		scope: string;
	}

	export interface IPhotoWithLoadedImage<T extends IPhoto = IPhoto> {
		photo: T;
		image: HTMLImageElement;
	}

	export interface IGetDesignsResult {
		designCount: any;
		designFilterCount: any;
		designs: core.IDesign[];
	}

	export interface IDesign {
		readonly alternativeColors?: IAlternativeColor[];
		readonly color: string;
		readonly displayPrice: string;
		readonly displayPricePerUnit: string;
		readonly showStar: boolean;
		readonly dspName: string;
		readonly dspOverlayUrl: string;
		readonly new: boolean;
		readonly openDspOverlayUrl: string;
		readonly packshotUrl: string;
		readonly predefinedProductName: string;
		readonly product: IProduct;
		readonly productAlternativesGroups: IProductAlternativesGroup[];
		readonly productCategory: IProductCategory;
		readonly productCategoryCode: string;
		readonly productCategoryGroupCode: string;
		readonly productCategoryGroups: string[];
		readonly productCode: string;
		readonly pvc: string;
		readonly top: boolean;
		readonly temporaryUnavailable: boolean;
		readonly productVariantName: string;
		readonly dimensions: string;
		readonly canSwitchBackgroundInCreator: boolean;
		readonly hasSets: boolean;
		readonly supportsPersonalData: boolean;
		readonly debug: string;
	}

	export interface IConstellation {
		constellationName: string;
		productCode: string;
		productName: string;
		shortName: string;
	}

	export interface IAlternativeColor {
		color: string;
		designVariant?: IDesignVariant;
		predefinedProductName: string;
		productCode: string;
	}

	export interface IDesignVariant {
		designVariantName: string;
		icon: string;
		iconColorCode: string;
	}

	export interface IProduct {
		name: string;
		shortName: string;
		designVariantInListDSP: services.InDsp;
		designVariantInOpenDSP: services.InDsp;
	}

	export interface IProductAlternativesGroup {
		inCreator: any;
		inListDSP: services.InDsp;
		inOpenDsp: services.InDsp;
		productAlternatives: IProductAlternative[];
		title: string;
	}

	export interface IProductAlternative {
		designWillBeLost: boolean;
		icon: string;
		iconColorCode: string;
		iconOverlayColorCode: string;
		orientation: services.Orientation;
		predefinedProductName: string;
		productCategoryCode: string;
		productCode: string;
		productVariantCode: string;
		title: string;
	}

	export interface IProductCategory {
		name: string;
		shortName: string;
		showMeasurements: boolean;
	}

	export interface IDesignDetail {
		attributeDetails?: IDesignAttributeDetails;
		disableOverlays: boolean;
		editorStartLink: string;
		productDimensions: string;
		productOptionGroups?: IDesignProductOptionGroup[];
		productPreviewImageCount: number;
		productPreviewImageUrls: string[];
		quantityBreakPriceDetails: IDesignQuantityBreakPriceDetails;
		shipmentDetails: { [key: string]: any };
		usps: string;
		variablePriceDetails: any | null;
		promotionDetails?: any;
	}

	export interface IDspMultiProductPageContext {
		promoCode: string;
		labelStartingPrice: string;
		labelExpandableUpTo: string;
		labelExtraPage: string;
		labelYourChoice: string;
		labelMeasurements: string;
		labelStartingAt: string;

		// used by utils.displayPrice
		currencySymbol: string;
		decimalSeparator: string;
		displayCurrencyLeft: string;

		// switches
		disableFilterCounters?: boolean;
		enableOrientationFilter?: boolean;
		enablePredefinedProductCategoryFilter?: boolean;
		enableColorFilter?: boolean;
		enableNumberOfPhotosFilter?: boolean;
		enablePriceFilter?: boolean;
		enableGenderFilter?: boolean;
		amountOfDesignsToFetch?: number;

		/**
		 * May not be set.
		 * Only used if SOCIALIMAGE is used as placeholder in .social-template
		 */
		cdn?: string;
	}

	export interface IDesignQuantityBreakPriceDetails {
		defaultQuantityBreaks: number;
		quantityBreaks: IDesignQuantityBreak[];
	}

	export interface IDesignQuantityBreak {
		break: number;
		price: number;
	}

	export interface IDesignProductOptionGroup {
		code: string;
		name: string;
		inCreator: any;
		inDsp: any;
		inOptionPage: any;
		description: string;
		productOptions: IDesignProductOption[] | null;
		siblingDataOptionUSPs?: any;
		siblingDataPageTitle?: string;
		specification?: any;
		title: string;
	}

	export interface IDesignProductOption {
		code: string;
		openDspOverlayUrl?: string;
		dspOverlayUrl?: string;
		alternativeOptionGroup: string;
		name: string;
		price: number;
		varPrice: number;
		shortName: string;
		specification?: any;
		varAmount: number;
		defaultProductOption: boolean;
	}

	export interface IDesignAttributeDetails {
		name: string;
		values?: IDesignAttributeDetailsValue[];
	}

	export interface IDesignAttributeDetailsValue {
		code: string;
		// whether this option is the default
		default: boolean;
		name: string;
		quantityBreakPriceDetails: any | null;
	}

	export class LoginManager {
		private accountService: eXpress.services.AccountService;

		private timer: number;
		private startingAccId: string;
		private accountType: string;

		constructor(accountService: eXpress.services.AccountService) {
			this.accountService = accountService;
			this.timer = -1;
		}

		public start(accountType: string): void {
			if (this.timer < 0) {
				this.startingAccId = GetCookie("accid");
				this.accountType = accountType;
				// @ts-ignore
				this.timer = setInterval(() => { this.run(); }, 1500);
			}
		}

		public stop(): void {
			if (this.timer > 0)
				clearTimeout(this.timer);
		}

		private run(): void {
			const currentAccountId = GetCookie("accid");
			if (this.startingAccId !== currentAccountId) {
				if (!currentAccountId || currentAccountId === emptyGuid) {
					// User logged out in another tab
					this.alertUser('LoginManager.LogoutInDifferentTab');
					clearTimeout(this.timer);
				}
				else {
					// User is logged in with a different account.
					if (this.accountType === 'full') {
						// We used to be a FULL, now a different account -> Impossible
						this.alertUser('LoginManager.DifferentAccount');

						clearTimeout(this.timer);
					}
					else {
						// TEMP got merged into FULL -> OK
						// Different FULL -> NOK
						// We need a webservice call for this ...
						this.accountService.checkAccountValidityAsync(this.startingAccId, currentAccountId).then(res => {
							if (!res) {
								this.alertUser('LoginManager.DifferentAccount');
							}
							else {
								this.startingAccId = currentAccountId;
							}
						});
					}
				}
			}
		}

		private alertUser(key: string) {
			if ($("html").hasClass("has-open-dialog"))
				window.CloseResponsiveDialog(undefined);

			window.ShowContentDialog({
				label: key,
				okContentKey: 'Label.RefreshButtonText',
				cssClass: 'rspdialog',
				dialogId: 'loggedDifferentTab',
				okFunction: () => {
					$(window).unbind('beforeunload');
					window.location.reload();
				}
			});
		}
	}

	export interface Map<T> {
		[K: string]: T;
	}

	export class KeyValuePair<T> {
		public Key: string;
		public Value: T;
	}

	export class CustomHtmlElementsApp {
		protected isInDiv = false;
		protected controlHasFocus = false;
		protected isMobile: boolean = (window.innerWidth <= 960 && window.innerHeight <= 960);

		protected addHandlers(): void {
			$(window).resize(() => {
				this.isMobile = (window.innerWidth <= 960 && window.innerHeight <= 960);
			});

			$(".selectbox-choices").on("mouseleave", () => {
				if (this.controlHasFocus) {
					this.isInDiv = true;
					this.controlHasFocus = false;
				}
			});

			$(".slider input[type=text]").on("mousedown", () => {
				this.controlHasFocus = true;
			});

			$(".slider input[type=text]").on("mouseup", () => {
				this.controlHasFocus = false;
			});

			$(document).on("click", (e) => {
				if (!this.isInDiv) this.closeAllDropdowns();

				this.isInDiv = false;
			});

			$(document).on("click", ".multiselect .selectBox", (e) => {
				this.stopBubble(e, false);
				const $target = $(e.currentTarget);
				if ($target.hasClass("open")) {
					this.closeAllDropdowns();
				} else {
					this.closeAllDropdowns();
					const $list = $target.closest('.multiselect').children('.checkboxes');
					$target.toggleClass("open");
					$list.toggle();
					$('section.dsp').css("cursor", "pointer");
				}
			});

			$(document).on("click", ".filter-toggle", (e) => {
				$(".filter-toggle").toggleClass("open");
				$(".filter-choice").toggleClass("open");
				$(".filter-container").toggleClass("open");

				if ($(".tag.filter-choice").hasClass("open")) {
					$('.main.small.filter-toggle').prop('disabled', true);
					$(".button.own-designs").hide();
				} else {
					$(".button.own-designs").show();
				}
			});
		}

		public stopBubble(event: any, closeFilters: boolean): void {
			event.preventDefault();
			event.stopPropagation();
			if (closeFilters)
				this.closeAllDropdowns();
		}

		public closeAllDropdowns() {
			$(".multiselect .selectBox").removeClass('open');
			$(".multiselect .checkboxes").hide();
			$('section.dsp').css("cursor", "");
			$(".info-wrapper .bottom-center").removeClass('open');
			$('.prints-amount .top-info-container').removeClass('open');
		}
	}

	export class DropdownElements extends CustomHtmlElementsApp {
		public start() {
			this.addHandlers();
		}
	}

	// storage

	// start storage enums

	export enum SortOrder {
		Ascending = 0,
		Descending = 1
	}

	export enum PhotoSortBy {
		DateTaken = 0,
		DateUploaded = 1,
		DateModified = 2,
		Name = 3,
		OriginalFilename = 4
	}

	// end storage enums

	// start storage types

	export type StoreCode = "eXpress" | "Facebook" | "GooglePhotos" | "Instagram" | "SwissCom";

	export type AnyPhoto = Photo | partners.PartnerPhoto;

	// end storage types

	// start storage interfaces
	export interface IPhotoSortOptions {
		sortBy: PhotoSortBy;
		sortOrder: SortOrder;
	}

	export interface IPhotoOriginal {
		readonly id: string;
		readonly code: string;
		readonly accountId: string;
		readonly folderId: string;
		readonly name: string;
		readonly description: string;
		readonly originalFilename: string;
		readonly thumbUrl: string;
		readonly mediumUrl: string;
		readonly relativeMediumUrl: string;
		readonly width: number;
		readonly height: number;
		readonly rotate90: number;
		readonly fileSize: number;
		readonly dateTaken: Date;
		readonly dateUploaded: Date;
		readonly dateModified: Date;
	}

	export interface IPhoto {
		readonly code: string;
		readonly name: string;
		readonly description: string;
		readonly originalFilename: string;
		readonly thumbUrl: string;
		readonly mediumUrl: string;
		readonly width: number;
		readonly height: number;
		readonly fileSize: number;
		readonly dateTaken?: Date;
		readonly dateUploaded?: Date;
		readonly dateModified?: Date;
		readonly rotate90?: number;
	}

	export interface IPhotoStore {
		readonly name: string;
		readonly connectedUserName: string;
		readonly isConnected: boolean;
		readonly showAlbum: boolean;
		readonly showTokenExpiry: boolean;
		readonly hasAlbumAccess: boolean;
		readonly partnerLogoSvgUrl: string;
		readonly locatePhotosUrl: string;
		readonly importPhotosUrl: string;
		readonly useExternalPhotoPicker: boolean;
		readonly code: StoreCode;
		readonly storeType: StoreType;
		getFoldersAsync: () => JQueryPromise<IPhotoFolder[] | null>;
		getTokenExpiry: () => JQueryPromise<eXpress.core.TokenExpiry>;
	}

	export interface IPhotoFolder {
		readonly id?: string;
		fileCount: number;
		name: string;
		thumbUrl?: string;
		mediumUrl?: string;
		readonly dateCreated?: Date;
		readonly code?: string;

		getPhotosAsync(page: number, pageSize: number, sortBy: PhotoSortBy, sortOrder: SortOrder, pageToken?: string): JQueryPromise<AnyPhoto[]>;
		getAllFileIdsAsync(): JQueryPromise<string[]>;
		clone(): IPhotoFolder;
	}

	export interface ISmartphotoPhoto extends IPhoto {
		readonly fileId: string;
		readonly dateTaken: Date;
		readonly dateUploaded: Date;
		readonly dateModified: Date;
		readonly rotate90: number;
		readonly folderId: string;
		readonly hash: string;
		rotate90Cw(): void;
	}

	// end storage interfaces

	// start storage classes

	export class Photo implements ISmartphotoPhoto {
		public readonly fileId: string;
		public readonly code: string;
		public readonly name: string;
		public readonly description: string;
		public readonly originalFilename: string;
		public readonly thumbUrl: string;
		public mediumUrl: string;
		public readonly width: number;
		public readonly height: number;
		public rotate90: number;
		public readonly fileSize: number;
		public readonly dateTaken: Date;
		public readonly dateUploaded: Date;
		public readonly dateModified: Date;
		public readonly folderId: string;
		public readonly hash: string;

		private relativeMediumUrl: string;
		private mediumUrlOriginal: string;

		constructor(id: string, name: string, dateTaken: Date, dateModified: Date, dateUploaded: Date, description: string,
			fileSize: number, folderId: string | null, height: number, mediumUrl: string, originalFileName: string, thumbUrl: string,
			width: number, rotate90: number, relativeMediumUrl: string, hash: string | null) {
			this.fileId = id;
			this.code = id;
			this.name = name;
			this.dateTaken = dateTaken;
			this.dateModified = dateModified;
			this.dateUploaded = dateUploaded;
			this.description = description;
			this.width = width;
			this.height = height;
			this.originalFilename = originalFileName;
			this.thumbUrl = thumbUrl;
			this.mediumUrl = mediumUrl;
			this.rotate90 = rotate90;
			this.relativeMediumUrl = relativeMediumUrl;
			this.mediumUrlOriginal = mediumUrl;
			this.fileSize = fileSize;
			this.setMediumUrl();
			this.folderId = folderId || "";
			this.hash = hash || "";
		}

		public rotate90Cw() {
			this.rotate90 = this.rotate90 + 90 % 360;
			this.setMediumUrl();
		}

		private setMediumUrl() {
			this.mediumUrl = this.rotate90 !== 0 ? this.relativeMediumUrl + "&rot90=" + this.rotate90 : this.mediumUrlOriginal;
		}
	}

	export abstract class BaseStore implements IPhotoStore {
		public name: string;
		public connectedUserName: string;
		public isConnected: boolean;
		public showAlbum: boolean;
		public showTokenExpiry: boolean;
		public hasAlbumAccess: boolean;
		public partnerLogoSvgUrl: string;
		public locatePhotosUrl: string;
		public importPhotosUrl: string;
		public useExternalPhotoPicker: boolean;
		public code: core.StoreCode;
		public storeType: StoreType;
		public page: number;
		public pageSize: number;
		public pageToken: string;
		public storageService: eXpress.services.StorageService;

		public constructor(
			name: string,
			username: string,
			isConnected: boolean,
			storeType: StoreType,
			storageService: services.StorageService,
			showAlbum: boolean,
			showTokenExpiry: boolean,
			hasAlbumAccess: boolean,
			partnerLogoSvgUrl: string,
			locatePhotosUrl: string,
			importPhotosUrl: string,
			useExternalPhotoPicker: boolean) {
			this.name = name;
			this.connectedUserName = username;
			this.isConnected = isConnected;
			this.storeType = storeType;
			this.code = services.StoreType[this.storeType] as core.StoreCode;
			this.storageService = storageService;
			this.showAlbum = showAlbum;
			this.showTokenExpiry = showTokenExpiry;
			this.hasAlbumAccess = hasAlbumAccess;
			this.partnerLogoSvgUrl = partnerLogoSvgUrl;
			this.locatePhotosUrl = locatePhotosUrl;
			this.importPhotosUrl = importPhotosUrl;
			this.useExternalPhotoPicker = useExternalPhotoPicker;
			this.page = 1;
			this.pageSize = 999; // effectively disable paging
			this.pageToken = '';
		}

		abstract getFoldersAsync(): JQueryPromise<IPhotoFolder[] | null>;
		abstract getTokenExpiry(): JQueryPromise<eXpress.core.TokenExpiry>;
	}

	export class ExpressStore extends BaseStore {
		constructor(
			name: string,
			username: string,
			isConnected: boolean,
			storageService: services.StorageService,
			showAlbum: boolean,
			hasAlbumAccess: boolean,
			partnerLogoSvgUrl: string,
			locatePhotosUrl: string,
			importPhotosUrl: string,
			useExternalPhotoPicker: boolean) {
			super(name, username, isConnected, StoreType.eXpress, storageService, showAlbum, false, hasAlbumAccess, partnerLogoSvgUrl, locatePhotosUrl, importPhotosUrl, useExternalPhotoPicker);
		}

		public connectToAsync(): JQueryPromise<boolean> {
			// once we probably want to include login functionality here
			// for now we will always resolve with the current folder
			return $.Deferred<boolean>().resolve(true).promise();
		}

		public getFoldersAsync(): JQueryPromise<core.IPhotoFolder[] | null> {
			return this.storageService.getFolderListWithThumbAsync(GetCookie("accid"), context.pointOfSaleId, GetCookie("accid"));
		}

		public getTokenExpiry(): JQueryPromise<eXpress.core.TokenExpiry> {
			throw new Error("Not implemented");
		}
	}

	export abstract class BaseFolder implements IPhotoFolder {
		public id: string;
		public fileCount: number;
		public name: string;
		public thumbUrl: string;
		public mediumUrl: string;
		public dateCreated: Date | undefined;

		protected storageService: services.StorageService;

		constructor(storageService: services.StorageService) {
			this.storageService = storageService;
		}

		public clone(): SmartphotoFolder {
			const clone = new SmartphotoFolder(this.storageService);
			clone.id = this.id;
			clone.fileCount = this.fileCount;
			clone.name = this.name;
			clone.thumbUrl = this.thumbUrl;
			clone.dateCreated = this.dateCreated;
			clone.mediumUrl = this.mediumUrl;
			return clone;
		}

		abstract getPhotosAsync(page: number, pageSize: number, sortBy: PhotoSortBy, sortOrder: SortOrder, pageToken?: string): JQueryPromise<Photo[] | partners.PartnerPhoto[]>;
		abstract getAllFileIdsAsync(): JQueryPromise<string[]>;
	}

	export class SmartphotoFolder extends BaseFolder {
		public getPhotosAsync(page: number, pageSize: number, sortBy = PhotoSortBy.DateTaken, sortOrder = SortOrder.Ascending, pageToken?: string): JQueryPromise<Photo[]> {
			return this.storageService.getPhotosByFolderAsync(context.pointOfSaleId, GetCookie("accid"), this.id, page, pageSize, sortBy, sortOrder, false);
		}

		public getPhotosByIdsAsync(folderId: string, ids: string[], useDeselected: boolean, isSelectAllActive: boolean): JQueryPromise<core.IPhoto[]> {
			return this.storageService.getPhotosAsync(context.pointOfSaleId, GetCookie("accid"), folderId, ids, useDeselected, isSelectAllActive);
		}

		public getAllFileIdsAsync(): JQueryPromise<string[]> {
			return this.storageService.getFileIdsInFolderAsync(GetCookie("accid"), this.id);
		}
	}

	// end storage classes

	// enums

	export enum Rotate90 {
		None = 0,
		Right = 90,
		UpsideDown = 180,
		Left = 270,
	}

	// start orderservice interfaces
	export enum UpdateShoppingCartAction {
		None = 0,
		Add,
		Update,
		Remove
	}

	export interface IOrderQuantiy {
		pvc: string;
		crossSellFrom: string;
		quantity: number;
	}

	export interface IUpdateShoppingCartResult {
		redirectUrl: string;
		totalPrice: number;
		action: UpdateShoppingCartAction;
		cartItemIds: string[];
	}

	export interface IUpdateCartItemQuantityResult {
		cartItem: ICartItem;
		success: boolean;
	}

	export interface ICartItem {
		id: string;
		quantity: number;
	}

	// end orderservice interfaces

	// start mediastore

	export namespace mediastore {
		export class PhotoReference {
			public id: string;
			public manipulations: Manipulations;
			public photoId: string;
		}

		export class Manipulations {
			public colorEffect: string | null;
			public height: number;
			public left: number;
			public rotate90: number;
			public top: number;
			public width: number;
		}

		/**
		 * Get orientation after crop and rotation
		 * @param item
		 */
		export function itemGetOrientation(item: PhotoReference): string {
			let width = item.manipulations.width;
			let height = item.manipulations.height;
			if (item.manipulations.rotate90 === 90 || item.manipulations.rotate90 === 270) {
				const temp = height;
				height = width;
				width = temp;
			}

			// fall back original if no dimensions are found:
			if (height === 0 && width === 0) {
				if (item instanceof eXpress.core.bulkeditor.CartItem) {
					const cartItem = item as eXpress.core.bulkeditor.CartItem;
					width = cartItem.originalWidth;
					height = cartItem.originalHeight;
				}

				else {
					// will default to square mode
				}
			}

			if (height === width)
				return 'square';
			else if (height > width)
				return 'portrait';
			else
				return 'landscape';
		}
	}
	// end mediastore
}

namespace eXpress.platforms {
	export class BasePlatform implements IPlatform {
		public setTimeout(delayInMs: number, callback: (timer: IDisposable) => void): IDisposable {
			const timer = {
				id: setTimeout(() => {
					// @ts-ignore
					delete timer.id;
					callback(timer);
				}, delayInMs),
				dispose: (): void => {
					if (timer.id) {
						clearTimeout(timer.id);
						// @ts-ignore
						delete timer.id;
					}
				}
			};

			return timer;
		}

		// Generate guid implementation
		// The Math.random has a lot of collisions, especially on chrome. Better to use the cryptography API. On chrome and so on this is windows.crypto.
		// On ie this is window.msCrypto. Fallback to the standard Math.Random version if neither exists
		public generateNewGuid(): string {

			let buf: Uint16Array;
			let S4: Function;
			const crypto = (window as any).crypto;
			const msCrypto = (window as any).msCrypto;

			if (typeof crypto !== "undefined" &&
				typeof crypto.getRandomValues !== "undefined") {
				// If we have a cryptographically secure PRNG, use that
				// http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
				buf = new Uint16Array(8);
				crypto.getRandomValues(buf);
				S4 = function (num: number): string {
					let ret = num.toString(16);
					while (ret.length < 4) {
						ret = "0" + ret;
					}
					return ret;
				};
				return (S4(buf[0]) + S4(buf[1]) + "-" + S4(buf[2]) + "-" + S4(buf[3]) + "-" + S4(buf[4]) + "-" + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
			}
			else if (typeof msCrypto !== "undefined" &&
				typeof msCrypto.getRandomValues !== "undefined") {
				// If we have a cryptographically secure PRNG, use that
				// http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
				buf = new Uint16Array(8);
				msCrypto.getRandomValues(buf);
				S4 = function (num: number): string {
					let ret = num.toString(16);
					while (ret.length < 4) {
						ret = "0" + ret;
					}
					return ret;
				};
				return (S4(buf[0]) + S4(buf[1]) + "-" + S4(buf[2]) + "-" + S4(buf[3]) + "-" + S4(buf[4]) + "-" + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
			}
			else {
				// Otherwise, just use Math.random
				// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c): string {
					/* tslint:disable:no-bitwise triple-equals */
					const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
					/* tslint:enable:no-bitwise triple-equals */
					return v.toString(16);
				});
			}
		}
	}
}

namespace eXpress {
	export const base: IPlatform = new platforms.BasePlatform();
}


namespace eXpress.core.partners {
	interface IPartnerPhoto extends IPhoto {
		readonly hiresUrl: string;
		readonly downloadUrl: string;
		readonly storeType: StoreType;
	}

	// classes

	export class PartnerStore extends BaseStore {

		constructor(
			name: string,
			username: string,
			isConnected: boolean,
			storeType: StoreType,
			storageService: services.StorageService,
			showAlbum: boolean,
			showTokenExpiry: boolean,
			hasAlbumAccess: boolean,
			partnerLogoSvgUrl: string,
			locatePhotosUrl: string,
			importPhotosUrl: string,
			useExternalPhotoPicker: boolean) {
			super(name, username, isConnected, storeType, storageService, showAlbum, showTokenExpiry, hasAlbumAccess, partnerLogoSvgUrl, locatePhotosUrl, importPhotosUrl, useExternalPhotoPicker);
		}

		public getFoldersAsync(): JQueryPromise<core.IPhotoFolder[] | null> {
			return this.storageService.getPartnerAlbumsAsync(this.code, GetCookie("accid"), context.pointOfSaleId, this.page, this.pageSize, this.pageToken);
		}

		public getTokenExpiry(): JQueryPromise<eXpress.core.TokenExpiry> {
			return this.storageService.getTokenExpiry(this.code, GetCookie("accid"), context.pointOfSaleId);
		}
	}

	export class PartnerFolder extends BaseFolder {
		public readonly storeType: StoreType;
		public pageToken: string;
		private photos: core.partners.PartnerPhoto[];

		constructor(storeType: StoreType, storageService: services.StorageService) {
			super(storageService);
			this.storeType = storeType;
		}

		public getPhotosAsync(page: number, pageSize: number, sortBy: PhotoSortBy, sortOrder: SortOrder, pageToken?: string): JQueryPromise<partners.PartnerPhoto[]> {
			return this.storageService.getPartnerPhotosInFolderAsync(this.id, this.storeType, GetCookie("accid"), context.pointOfSaleId, page, pageSize, pageToken)
				.then(photos => {
					if (!photos)
						throw new Error(`PartnerFolder.getPhotosAsync returned undefined for partner:  ${StoreType[this.storeType]}`);

					this.photos = photos;
					return this.photos;
				});
		}

		public getAllFileIdsAsync(): JQueryPromise<string[]> {
			return $.Deferred<string[]>().resolve(this.photos.map(photo => photo.code)).promise();
		}
	}

	export class PartnerPhoto implements IPartnerPhoto {
		public fileId?: string;
		public readonly code: string;
		public readonly name: string;
		public readonly description: string;
		public readonly originalFilename: string;
		public readonly thumbUrl: string;
		public readonly mediumUrl: string;
		public readonly width: number;
		public readonly height: number;
		public readonly fileSize: number;
		public readonly dateTaken: Date;
		public readonly dateUploaded: Date;
		public readonly dateModified: Date;
		public readonly hiresUrl: string;
		public readonly downloadUrl: string;
		public readonly storeType: services.StoreType;
		public readonly pageToken: string;

		constructor(id: string, name: string, dateTaken: Date, dateModified: Date, dateUploaded: Date, description: string,
			fileSize: number, folderId: string, height: number, mediumUrl: string, originalFileName: string, thumbUrl: string,
			width: number, hiresUrl: string, downloadUrl: string, storeType: StoreType, code: string, pageToken: string) {
			this.fileId = id;
			this.name = name;
			this.dateTaken = dateTaken;
			this.dateModified = dateModified;
			this.dateUploaded = dateUploaded;
			this.description = description;
			this.width = width;
			this.height = height;
			this.originalFilename = originalFileName;
			this.thumbUrl = thumbUrl;
			this.mediumUrl = mediumUrl;
			this.storeType = storeType;
			this.hiresUrl = hiresUrl;
			this.downloadUrl = downloadUrl;
			this.code = code;
			this.pageToken = pageToken;
		}
	}

	// end classes
}

namespace eXpress.serialization {

	export function convertPhotoIdToStorageIdWithoutAccountId(photoStorageIds: string[]): eXpress.services.IStorageId[] {
		return photoStorageIds.map(photoId => ({
			Id: photoId
		}));
	}

	export function convertPhotoIdToStorageId(photoStorageIds: string[], accountId: string): eXpress.services.IStorageId[] {
		return photoStorageIds.map(photoId => ({
			Id: photoId,
			AccountId: accountId
		}));
	}

	export function convertStoreCodeToStoreType(code: eXpress.core.StoreCode): eXpress.services.StoreType {
		return eXpress.services.StoreType[code];
	}

	// OrderService serialisation

	export function OrderQuantityConvert(quantity: eXpress.core.IOrderQuantiy): eXpress.services.IOrderQuantiy {
		return {
			Quantity: quantity.quantity,
			CrossSellFrom: quantity.crossSellFrom,
			Pvc: quantity.pvc
		};
	}

	export function cartItemConvert(item: eXpress.core.bulkeditor.CartItem): eXpress.services.bulkeditor.ICartItem {
		return {
			ApplyAllFailed: item.applyAllFailed,
			CreatedForced: item.createdForced ? eXpress.utils.formatWcfJsonDate(item.createdForced) : null,
			DateModifiedParent: item.dateModifiedParent ? eXpress.utils.formatWcfJsonDate(item.dateModifiedParent) : null,
			DatePictureTaken: item.datePictureTaken ? eXpress.utils.formatWcfJsonDate(item.datePictureTaken) : null,
			FileSize: item.fileSize,
			Id: item.id,
			Manipulations: manipulationsConvert(item.manipulations),
			OriginalFileName: item.originalFileName,
			OriginalHeight: item.originalHeight,
			OriginalWidth: item.originalWidth,
			PhotoCounter: item.photoCounter,
			PhotoId: item.photoId,
			Products: item.products.map(p => cartItemProductConvert(p)),
			ThumbUrl: "",
			MediumUrl: ""
		};
	}

	export function simpleCartItemConvert(item: eXpress.core.bulkeditor.CartItem): eXpress.services.bulkeditor.ISimpleCartItem {
		return {
			Products: item.products.map(p => cartItemProductConvert(p))
		};
	}

	export function manipulationsConvert(manipulations: eXpress.core.mediastore.Manipulations): eXpress.services.bulkeditor.IManipulations {
		return {
			ColorEffect: manipulations.colorEffect,
			Height: manipulations.height,
			Left: manipulations.left,
			Rotate90: manipulations.rotate90,
			Top: manipulations.top,
			Width: manipulations.width
		};
	}

	export function cartItemProductConvert(apiObject: eXpress.core.bulkeditor.CartItemProduct): eXpress.services.bulkeditor.ICartItemProduct {
		return {
			Border: apiObject.border,
			ColorEffect: apiObject.colorEffect,
			Paper: apiObject.paper,
			ProductCode: apiObject.productCode,
			Quantity: apiObject.quantity,
			CartItemId: apiObject.cartItemId
		};
	}

	export function productConvert(apiObject: eXpress.services.bulkeditor.IProduct): eXpress.core.bulkeditor.Product {
		return {
			attributes: apiObject.Attributes,
			attributesDict: apiObject.AttributesDict,
			code: apiObject.Code,
			options: apiObject.Options,
			optionsDict: apiObject.OptionsDict
		};
	}
}

namespace eXpress.deserialization {

	/* Design && DesignDetail */

	export function getDesignsResultConvert(obj: eXpress.services.IGetDesignsResult): eXpress.core.IGetDesignsResult {
		return {
			designCount: obj.DesignCount,
			designFilterCount: obj.DesignFilterCount,
			designs: obj.Designs.map(d => designConvert(d))
		};
	}

	export function designConstellationConvert(obj: services.IConstellation): core.IConstellation {
		return {
			constellationName: obj.ConstellationName,
			productCode: obj.ProductCode,
			productName: obj.ProductName,
			shortName: obj.ShortName
		};
	}

	export function designAlternativeColorConvert(obj: services.IAlternativeColor): core.IAlternativeColor {
		return {
			color: obj.Color,
			designVariant: obj!.DesignVariant ? designVariantConvert(obj.DesignVariant) : undefined,
			predefinedProductName: obj.PredefinedProductName,
			productCode: obj.ProductCode
		};
	}

	export function designVariantConvert(obj: services.IDesignVariant): core.IDesignVariant {
		return {
			designVariantName: obj.DesignVariantName,
			icon: obj.Icon,
			iconColorCode: obj.IconColorCode
		};
	}

	export function designProductConvert(obj: services.IProduct): core.IProduct {
		return {
			name: obj.Name,
			shortName: obj.ShortName,
			designVariantInListDSP: obj.DesignVariantInListDSP as services.InDsp,
			designVariantInOpenDSP: obj.DesignVariantInOpenDSP as eXpress.services.InDsp
		};
	}

	export function designProductAlternativesGroupConvert(obj: eXpress.services.IProductAlternativesGroup): eXpress.core.IProductAlternativesGroup {
		return {
			inCreator: obj.InCreator,
			inListDSP: obj.InListDSP as services.InDsp,
			inOpenDsp: obj.InOpenDSP as services.InDsp,
			productAlternatives: obj.ProductAlternatives.map(pa => designProductAlternativeConvert(pa)),
			title: obj.Title
		};
	}

	export function designProductCategoryConvert(obj: services.IProductCategory): core.IProductCategory {
		return {
			name: obj.Name,
			shortName: obj.ShortName,
			showMeasurements: obj.ShowMeasurements
		};
	}

	export function designProductAlternativeConvert(obj: services.IProductAlternative): core.IProductAlternative {
		return {
			designWillBeLost: obj.DesignWillBeLost,
			icon: obj.Icon,
			iconColorCode: obj.IconColorCode,
			iconOverlayColorCode: obj.IconOverlayColorCode,
			orientation: services.Orientation[obj.Orientation],
			predefinedProductName: obj.PredefinedProductName,
			productCategoryCode: obj.ProductCategoryCode,
			productCode: obj.ProductCode,
			productVariantCode: obj.ProductVariantCode,
			title: obj.Title
		};
	}

	export function designAttributeDetailsValueConvert(obj: services.IDesignAttributeDetailsValue): core.IDesignAttributeDetailsValue {
		return {
			code: obj.Code,
			default: obj.Default,
			name: obj.Name,
			quantityBreakPriceDetails: obj.QuantityBreakPriceDetails
		};
	}

	export function designAttributeDetailsConvert(obj: services.IDesignAttributeDetails): core.IDesignAttributeDetails {
		return {
			name: obj.Name,
			values: obj.Values ? obj.Values.map(v => designAttributeDetailsValueConvert(v)) : undefined
		};
	}

	export function designQuantityBreakPriceDetailsConvert(obj: services.IDesignQuantityBreakPriceDetails): core.IDesignQuantityBreakPriceDetails {
		return {
			defaultQuantityBreaks: obj.DefaultQuantityBreaks,
			quantityBreaks: obj.QuantityBreaks.map(qb => designQuantityBreakConvert(qb))
		};
	}

	export function designQuantityBreakConvert(obj: services.IDesignQuantityBreak): core.IDesignQuantityBreak {
		return {
			break: obj.Break,
			price: obj.Price
		};
	}

	export function designProductOptionGroupConvert(obj: services.IDesignProductOptionGroup): core.IDesignProductOptionGroup {
		return {
			name: obj.Name,
			code: obj.Code,
			inDsp: obj.InDsp,
			inCreator: obj.InDsp,
			inOptionPage: obj.InOptionPage,
			description: obj.Description,
			productOptions: obj!.ProductOptions ? obj.ProductOptions.map(po => designProductOptionConvert(po)) : null,
			siblingDataOptionUSPs: obj.SiblingDataOptionUSPs,
			siblingDataPageTitle: obj.SiblingDataPageTitle,
			specification: obj.Specification,
			title: obj.Title
		};
	}

	export function designProductOptionConvert(obj: services.IDesignProductOption): core.IDesignProductOption {
		return {
			code: obj.Code,
			alternativeOptionGroup: obj.AlternativeOptionGroup,
			name: obj.Name,
			price: obj.Price,
			varPrice: obj.VarPrice,
			dspOverlayUrl: obj.DspOverlayUrl,
			openDspOverlayUrl: obj.OpenDspOverlayUrl,
			defaultProductOption: obj.DefaultProductOption,
			shortName: obj.ShortName,
			specification: obj.Specification,
			varAmount: obj.VarAmount
		};
	}

	export function designDetailConvert(obj: services.IDesignDetail): core.IDesignDetail {
		return {
			attributeDetails: obj!.AttributeDetails ? designAttributeDetailsConvert(obj.AttributeDetails) : undefined,
			disableOverlays: obj.DisableOverlays,
			editorStartLink: obj.EditorStartLink,
			productOptionGroups: obj!.ProductOptionGroups ? obj.ProductOptionGroups.map(pog => designProductOptionGroupConvert(pog)) : undefined,
			productPreviewImageCount: obj.ProductPreviewImageCount,
			productPreviewImageUrls: obj.ProductPreviewImageUrls,
			quantityBreakPriceDetails: designQuantityBreakPriceDetailsConvert(obj.QuantityBreakPriceDetails),
			shipmentDetails: obj.ShipmentDetails,
			usps: obj.USPs,
			variablePriceDetails: obj.VariablePriceDetails,
			promotionDetails: obj.PromotionDetails,
			productDimensions: obj.ProductDimensions
		};
	}

	export function designConvert(obj: services.IDesign): core.IDesign {
		return {
			alternativeColors: obj.AlternativeColors && obj.AlternativeColors.length > 0 ? obj.AlternativeColors.map(ac => designAlternativeColorConvert(ac)) : undefined,
			color: obj.Color,
			displayPrice: obj.DisplayPrice,
			displayPricePerUnit: obj.DisplayPricePerUnit,
			showStar: obj.ShowStar,
			dspName: obj.DspName,
			dspOverlayUrl: obj.DspOverlayUrl,
			new: obj.New,
			openDspOverlayUrl: obj.OpenDspOverlayUrl,
			packshotUrl: obj.PackshotUrl,
			predefinedProductName: obj.PredefinedProductName,
			product: designProductConvert(obj.Product),
			productAlternativesGroups: obj!.ProductAlternativesGroups ? obj.ProductAlternativesGroups.map(pag => designProductAlternativesGroupConvert(pag)) : [],
			productCategory: designProductCategoryConvert(obj.ProductCategory),
			productCategoryCode: obj.ProductCategoryCode,
			productCategoryGroupCode: obj.ProductCategoryGroupCode,
			productCategoryGroups: obj.ProductCategoryGroups,
			productCode: obj.ProductCode,
			pvc: obj.Pvc,
			top: obj.Top,
			temporaryUnavailable: obj.TemporaryUnavailable,
			productVariantName: obj.ProductVariantName,
			dimensions: obj.Dimensions,
			canSwitchBackgroundInCreator: obj.CanSwitchBackgroundInCreator,
			hasSets: obj.HasSets,
			supportsPersonalData: obj.SupportsPersonalData,
			debug: obj.Debug
		};
	}

	/* End Design && DesignDetail */


	export function photoFolderConvert(folder: eXpress.services.IPhotoFolder, storageService: services.StorageService): core.SmartphotoFolder {
		// validate
		if (!folder.Id)
			throw new Error("Can't deserialize a folder without id.");

		const angle = ((folder.ThumbUrlRotation90 || 0) + 360) % 360;
		const angleRotate90: eXpress.core.Rotate90 = angle;
		const coreFolder = new core.SmartphotoFolder(storageService);
		coreFolder.id = folder.Id;
		coreFolder.name = folder.Name;
		coreFolder.fileCount = folder.FileCount;
		coreFolder.thumbUrl = angle ? (folder.ThumbUrl + "&rot90=" + angleRotate90) : folder.ThumbUrl;
		coreFolder.mediumUrl = angle ? (folder.MediumUrl + "&rot90=" + angleRotate90) : folder.MediumUrl;
		coreFolder.dateCreated = deserialiseDate(folder.DateCreated) || undefined;
		return coreFolder;
	}

	export function photoFolderDataConvert(folder: eXpress.services.IFolderData, storageService: services.StorageService): core.SmartphotoFolder {
		// validate
		if (!folder.id)
			throw new Error("Can't deserialize a folder without id.");

		const coreFolder = new core.SmartphotoFolder(storageService);
		coreFolder.id = folder.id;
		coreFolder.name = folder.name;
		coreFolder.fileCount = folder.fileCount;
		coreFolder.dateCreated = deserialiseDate(folder.dateCreated) || undefined;
		return coreFolder;
	}

	export function partnerFolderConvert(folder: eXpress.services.IPhotoFolder, storeType: services.StoreType, pageToken: string, storageService: services.StorageService) {
		if (!folder.Code) throw new Error("Can't deserialze partnerfolder with folder code");
		const coreFolder = new core.partners.PartnerFolder(storeType, storageService);
		coreFolder.id = folder.Code;
		coreFolder.name = folder.Name || "";
		coreFolder.fileCount = folder.FileCount;
		coreFolder.thumbUrl = folder.ThumbUrl;
		coreFolder.mediumUrl = folder.MediumUrl;
		coreFolder.dateCreated = deserialiseDate(folder.DateCreated) || undefined;
		coreFolder.pageToken = pageToken;
		return coreFolder;
	}

	export function photoConvert(apiObject: eXpress.services.IPhoto): core.Photo {
		return new core.Photo(apiObject.Id,
			apiObject.Name,
			deserialiseDate(apiObject.DateTaken),
			deserialiseDate(apiObject.DateModified),
			deserialiseDate(apiObject.DateUploaded),
			apiObject.Description,
			apiObject.FileSize,
			apiObject.FolderId,
			apiObject.Height,
			apiObject.MediumUrl,
			apiObject.OriginalFilename,
			apiObject.ThumbUrl,
			apiObject.Width,
			apiObject.Rotate90 || 0,
			apiObject.RelativeMediumUrl,
			apiObject.Hash);
	}

	export function partnerPhotoConvert(apiObject: eXpress.services.IPhoto, storeType: eXpress.services.StoreType, pageToken: string): eXpress.core.partners.PartnerPhoto {
		return new core.partners.PartnerPhoto(apiObject.Id,
			apiObject.Name,
			deserialiseDate(apiObject.DateTaken),
			deserialiseDate(apiObject.DateModified),
			deserialiseDate(apiObject.DateUploaded),
			apiObject.Description,
			apiObject.FileSize,
			apiObject.FolderId,
			apiObject.Height,
			apiObject.MediumUrl,
			apiObject.OriginalFilename,
			apiObject.ThumbUrl,
			apiObject.Width,
			apiObject.HiresUrl,
			apiObject.DownloadUrl,
			storeType,
			apiObject.Code,
			pageToken);
	}

	export function photoStoreConvert(apiObject: eXpress.services.IPhotoStore, storageService: eXpress.services.StorageService): eXpress.core.IPhotoStore {
		// return express store
		if (apiObject.StoreType === services.StoreType.eXpress)
			return new core.ExpressStore(
				apiObject.Name,
				apiObject.ConnectedUserName,
				apiObject.IsConnected,
				storageService,
				apiObject.ShowAlbum,
				apiObject.HasAlbumAccess,
				apiObject.PartnerLogoSvgUrl,
				apiObject.LocatePhotosUrl,
				apiObject.ImportPhotosUrl,
				apiObject.UseExternalPhotoPicker
			);
		// return partner store
		return new core.partners.PartnerStore(
			apiObject.Name,
			apiObject.ConnectedUserName,
			apiObject.IsConnected,
			apiObject.StoreType,
			storageService,
			apiObject.ShowAlbum,
			apiObject.ShowTokenExpiry,
			apiObject.HasAlbumAccess,
			apiObject.PartnerLogoSvgUrl,
			apiObject.LocatePhotosUrl,
			apiObject.ImportPhotosUrl,
			apiObject.UseExternalPhotoPicker
		);
	}

	// contentservice deserialisation
	export function BulkEditorGetAllProductsResultConvert(apiObject: eXpress.services.bulkeditor.IBulkEditorGetAllProductsResult): eXpress.core.bulkeditor.IBulkEditorGetAllProductsResult | null {
		if (!apiObject) return null;

		return {
			products: apiObject.Products.map(p => eXpress.deserialization.productConvert(p)),
			translations: apiObject.Translations,
			bulkSequenceShapes: apiObject.BulkSequenceShapes
		};
	}

	export function TokenExpiryConvert(tokenexpiry: eXpress.services.TokenExpiry): eXpress.core.TokenExpiry {
		return {
			countdownVisibleNumber: tokenexpiry.CountDownBarVisibleMinutes,
			tokenExpiryDate: eXpress.deserialization.deserialiseDate(tokenexpiry.TokenExpiryDate)
		};
	}

	// orderservice deserialisation
	export function UpdateShoppingCartResultConvert(apiObject: eXpress.services.IUpdateShoppingCartResult): eXpress.core.IUpdateShoppingCartResult {
		return {
			action: apiObject.Action,
			cartItemIds: apiObject.CartItemIds,
			redirectUrl: apiObject.RedirectUrl,
			totalPrice: apiObject.TotalPrice
		};
	}

	export function UpdateCartItemQuantityResultConvert(apiObject: eXpress.services.IUpdateCartItemQuantityResult): eXpress.core.IUpdateCartItemQuantityResult {
		return {
			cartItem: cartItemDataConvert(apiObject.CartItem),
			success: apiObject.Success
		};
	}

	// cartitemConvert names was already taken, therefor cartItemData
	export function cartItemDataConvert(apiObject: eXpress.services.ICartItem): eXpress.core.ICartItem {
		return {
			id: apiObject.Id,
			quantity: apiObject.Quantity
		};
	}

	export function cartItemConvert(apiObject: eXpress.services.bulkeditor.ICartItem): eXpress.core.bulkeditor.CartItem {
		return {
			applyAllFailed: apiObject.ApplyAllFailed,
			createdForced: deserialiseDate(apiObject.CreatedForced),
			dateModifiedParent: deserialiseDate(apiObject.DateModifiedParent),
			datePictureTaken: deserialiseDate(apiObject.DatePictureTaken),
			fileSize: apiObject.FileSize,
			id: apiObject.Id,
			manipulations: manipulationsConvert(apiObject.Manipulations),
			originalFileName: apiObject.OriginalFileName,
			originalHeight: apiObject.OriginalHeight,
			originalWidth: apiObject.OriginalWidth,
			photoCounter: apiObject.PhotoCounter,
			photoId: apiObject.PhotoId,
			products: apiObject.Products.map(p => cartItemProductConvert(p)),
			thumbUrl: apiObject.ThumbUrl,
			mediumUrl: apiObject.MediumUrl,
		};
	}

	export function manipulationsConvert(apiObject: eXpress.services.bulkeditor.IManipulations): eXpress.core.mediastore.Manipulations {
		return {
			colorEffect: apiObject.ColorEffect,
			height: apiObject.Height,
			left: apiObject.Left,
			rotate90: apiObject.Rotate90,
			top: apiObject.Top,
			width: apiObject.Width
		};
	}

	export function cartItemProductConvert(apiObject: eXpress.services.bulkeditor.ICartItemProduct): eXpress.core.bulkeditor.CartItemProduct {
		return {
			border: apiObject.Border,
			colorEffect: apiObject.ColorEffect,
			paper: apiObject.Paper,
			productCode: apiObject.ProductCode,
			quantity: apiObject.Quantity,
			cartItemId: apiObject.CartItemId
		};
	}

	export function productConvert(apiObject: eXpress.services.bulkeditor.IProduct): eXpress.core.bulkeditor.Product {
		return {
			attributes: apiObject.Attributes,
			attributesDict: apiObject.AttributesDict,
			code: apiObject.Code,
			options: apiObject.Options,
			optionsDict: apiObject.OptionsDict
		};
	}
}

namespace eXpress {
	export interface IPlatform {
		generateNewGuid(): string;
		setTimeout(delayInMs: number, callback: (timer: IDisposable) => void): IDisposable;
	}
}

namespace eXpress.core {
	export function showLoadingDialogAsync<T>(promise: JQueryPromise<T>, timeout = 500): JQueryPromise<T> {
		window.ShowLoadingDialog(timeout);
		const blockingEventDisposables = eXpress.html.disableUserEvents();
		return promise.always(() => {
			blockingEventDisposables.dispose();
			window.HideLoadingDialog();
		});
	}
	export function showLoadingDialogPromiseAsync<T>(promise: Promise<T>, timeout = 500): Promise<T> {
		window.ShowLoadingDialog(timeout);
		const blockingEventDisposables = eXpress.html.disableUserEvents();
		return promise.finally(() => {
			blockingEventDisposables.dispose();
			window.HideLoadingDialog();
		});
	}
}

// var globalHandled = false;
// $.event.special.tap = {
// 	// Abort tap if touch moves further than 10 pixels in any direction
// 	distanceThreshold: 10,
// 	// Abort tap if touch lasts longer than half a second
// 	timeThreshold: 500,
// 	setup: function () {
// 		var self = this,
// 			$self = $(self);

// 		// Bind touch start
// 		$self.on('touchstart', function (startEvent) {
// 			// Save the target element of the start event
// 			var target = startEvent.target,
// 				touchStart = startEvent.originalEvent.touches ? startEvent.originalEvent.touches[0] : startEvent.originalEvent,
// 				startX = touchStart.pageX,
// 				startY = touchStart.pageY,
// 				threshold = $.event.special.tap.distanceThreshold,
// 				timeout;
// 			globalHandled = false;

// 			function removeTapHandler() {
// 				clearTimeout(timeout);
// 				$self.off('touchmove', moveHandler).off('touchend', tapHandler);
// 			}

// 			function tapHandler(endEvent) {
// 				removeTapHandler();

// 				// When the touch end event fires, check if the target of the
// 				// touch end is the same as the target of the start, and if
// 				// so, fire a click.
// 				if (target === endEvent.target) {
// 					if (!globalHandled) {
// 						globalHandled = true;
// 						$.event.simulate('tap', self, endEvent);
// 					}
// 				}
// 			}

// 			// Remove tap and move handlers if the touch moves too far
// 			function moveHandler(moveEvent) {
// 				var touchMove = moveEvent.originalEvent.touches[0] ? moveEvent.originalEvent.touches[0] : moveEvent.originalEvent,
// 					moveX = touchMove.pageX,
// 					moveY = touchMove.pageY;

// 				if (Math.abs(moveX - startX) > threshold ||
// 					Math.abs(moveY - startY) > threshold) {
// 					removeTapHandler();
// 				}
// 			}

// 			// Remove the tap and move handlers if the timeout expires
// 			timeout = setTimeout(removeTapHandler, $.event.special.tap.timeThreshold);

// 			// When a touch starts, bind a touch end and touch move handler
// 			$self.on('touchmove', moveHandler).on('touchend', tapHandler);
// 		});
// 	}
// };
// /* tslint:enable:variable-name */
// /* tslint:enable:interface-name */

namespace eXpress {
	class Helpers {
		private isMobileField?: boolean;

		public get isMobileSize(): boolean {
			if (!eXpress.core.context.allowMobile)
				return false;

			if (this.isMobileField === undefined) {
				this.isMobileField = (window.innerWidth <= eXpress.core.context.mobileTransitionScreenWidth);
			}

			return this.isMobileField;
		}
	}

	export const helpers = new Helpers();
}

namespace eXpress.utils {
	/**
	* Checks if the given argument is undefined.
	*/
	export function isUndefined(obj: undefined): true;
	export function isUndefined(obj: any): obj is undefined;
	export function isUndefined(obj: any): obj is undefined {
		return (typeof obj) === "undefined";
	}

	export function required<T>(arg: T | null | undefined, message: string): T {
		if (!isUndefined(arg) && arg !== null) return arg;
		throw new Error("Missing required argument: " + message);
	}

	export function postAfterLinkClick(url: string, data: StringKeyValuePair[]) {
		const form = document.createElement("form");
		form.setAttribute("method", 'POST');
		form.setAttribute("action", url);
		data.forEach(kv => {
			const hiddenField = document.createElement("input");
			hiddenField.setAttribute("type", "hidden");
			hiddenField.setAttribute("name", kv.Key);
			hiddenField.setAttribute("value", kv.Value);
			form.appendChild(hiddenField);
		});
		document.body.appendChild(form);
		form.submit();
	}

	export function waitAsync<T>(delayInMs: number): JQueryPromise<void>;
	export function waitAsync<T>(delayInMs: number, resolveWith: T): JQueryPromise<T>;
	export function waitAsync<T>(delayInMs: number, resolveWith?: T): JQueryPromise<T | void> {
		const deferred = $.Deferred<T | void>();
		base.setTimeout(delayInMs, function waitAsyncTimeout() { deferred.resolve(resolveWith); }); // used function to have better call stack
		return deferred.promise();
	}

	export function isNonEmptyArray(obj: any): boolean {
		return Array.isArray(obj) && obj.length > 0;
	}

	export function changeUrlAndLog(tabName: string, tabValue?: string, skipChangeUrl = false) {
		let url = window.location.href;
		url = utils.updateParameter('tab', tabName, url);
		url = utils.updateParameter('tabvalue', tabValue || "", url);
		if (historyJs.replaceState && !skipChangeUrl) {
			historyJs.replaceState(null, "", url);
		}
	}

	export interface IRect { Top: number; Left: number; Width: number; Height: number; }

	export function displayPrice(price: number, addCurrency: boolean, addStar: boolean, context: any): string {
		let display = '';
		if (addCurrency && context.displayCurrencyLeft)
			display += context.currencySymbol + ' ';
		display += price.toFixed(2).replace('.', context.decimalSeparator);
		if (addCurrency && !context.displayCurrencyLeft)
			display += ' ' + context.currencySymbol;
		if (addStar)
			display += '*';
		return display;
	}

	export function calculateCrop(originalWidth: number, originalHeight: number, cropRatio): IRect {
		const result: IRect = { Top: 0, Left: 0, Width: 0, Height: 0 };
		let longestSide = originalWidth;
		let shortestSide = originalHeight;
		if (originalHeight > originalWidth) {
			longestSide = originalHeight;
			shortestSide = originalWidth;
		}

		let cropLongestSide = 0;
		let cropShortestSide = 0;
		if (longestSide * cropRatio >= shortestSide) {
			// It's too landscape, cut stuff from the longest side
			cropShortestSide = shortestSide;
			cropLongestSide = Math.round(cropShortestSide / cropRatio);
			result.Left = Math.round((longestSide - cropLongestSide) / 2);
			result.Top = 0;
		}
		else {
			// it's not landscape enough, cut stuff from the short side
			cropLongestSide = longestSide;
			cropShortestSide = Math.round(cropLongestSide * cropRatio);
			result.Left = 0;
			result.Top = Math.round((shortestSide - cropShortestSide) / 2);
		}

		if (originalWidth >= originalHeight) {
			result.Width = cropLongestSide;
			result.Height = cropShortestSide;
		}
		else {
			result.Width = cropShortestSide;
			result.Height = cropLongestSide;
			const x = result.Top;
			result.Top = result.Left;
			result.Left = x;
		}

		return result;
	}

	export function clone<T>(obj: T): T {
		const cloneObj = new (<any>obj).constructor();
		for (const attribute in obj) {
			if (typeof obj[attribute] === "object" && obj[attribute] !== null) {
				cloneObj[attribute] = utils.clone(obj[attribute]);
			}
			else {
				cloneObj[attribute] = obj[attribute];
			}
		}
		return cloneObj;
	}

	export function findFirst<T>(arr: T[], predicate: (element: T, i: number, arr: T[]) => boolean): T | undefined {
		let result: T | undefined = undefined;
		arr.some(function (el, i) {
			return predicate(el, i, arr) ? ((result = el), true) : false;
		});
		return result;
	}

	/**
	 *
	 * @param arr array to search in
	 * @param predicate
	 * @returns first element in array that matches the predicate or throws an error if no element found
	 */
	export function findFirstOrError<T>(arr: T[], predicate: (element: T, i: number, arr: T[]) => boolean): T {
		const result = findFirst(arr, predicate);
		if (!result) throw new Error("No element found in array that matches predicate ");
		return result;
	}

	export function findIndex<T>(arr: T[], predicate: (element: T, i: number, arr: T[]) => boolean): number {
		let index = -1;
		arr.some(function (el, i) {
			return predicate(el, i, arr) ? ((index = i), true) : false;
		});
		return index;
	}

	export function removeItem<T>(arr: T[], predicate: (element: T, i: number, arr: T[]) => boolean): T[] {
		const index = findIndex(arr, predicate);

		if (index > -1)
			arr.splice(index, 1);

		return arr;
	}

	export function parseWcfJsonDate(s: string): Date {
		const dateRegexResult = /Date\(([^)]+)\)/.exec(s);
		if (!dateRegexResult) throw new Error("Cannot parse WCF json date: " + s);

		return new Date(parseFloat(dateRegexResult[1]));
	}

	export function formatWcfJsonDate(date: Date): string {
		return '/Date(' + date.getTime() + ')/';
	}

	export function convertDateToUtcDate(date: Date): Date {
		return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
	}

	// returns format YYYY-MM-DD (for html5 date input fields)
	export function getFormattedDate(date: Date): string {
		let year = date.getFullYear().toString();
		year = year.length > 3 ? year
			: year.length > 2 ? '0' + year
				: year.length > 1 ? '00' + year
					: year.length > 0 ? '000' + year
						: '0000';
		let month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : '0' + month;
		let day = date.getDate().toString();
		day = day.length > 1 ? day : '0' + day;
		return year + '-' + month + '-' + day;
	}

	export function getDDMMYYYYDateWithHyphens(date: Date): string {
		const formattedString = getFormattedDate(date);
		const dateParts = formattedString.split("-");
		return utils.formatString("{0}-{1}-{2}", dateParts[2], dateParts[1], dateParts[0]);
	}

	export function getDate(dateString: string): Date {
		const regex = new RegExp(/(^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$)|(^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$)/);
		if (!regex.test(dateString))
			throw Error("invalid date format: " + dateString + ". Expected either YYYY-MM-DD or DD-MM-YYYY");

		let date: Date;
		const firstPart = dateString.substr(0, dateString.indexOf("-"));
		if (firstPart.length === 4)
			date = new Date(dateString);
		else {
			const dateParts = dateString.split("-").map(s => +s);
			date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
		}

		return date;
	}

	export function parseJsonDate(jsonDate) {
		// Get the date time part
		const dateTimePart = jsonDate.replace(/\/+Date\(([\d+-]+)\)\/+/, '$1');

		// Check for + or - sign
		const minusSignIndex = dateTimePart.indexOf('-');
		const plusSignIndex = dateTimePart.indexOf('+');

		// Get the sign index
		const signIndex = minusSignIndex > 0 ? minusSignIndex : plusSignIndex;

		// If sign index is not 0 then we are extracting offset part and
		let ms = 0;
		let offsetHours = 0;
		if (signIndex > 0) {
			const datePart = dateTimePart.substring(0, signIndex);
			const offsetPart = dateTimePart.substring(signIndex);
			const offset = offsetPart.substring(0, 3) + '.' + ((parseFloat(offsetPart.substring(3)) / 60) * 100).toString();
			ms = parseFloat(datePart);
			offsetHours = parseFloat(offset);
		}
		else {
			ms = parseFloat(dateTimePart);
		}

		const date = new Date(ms);

		// convert to msec
		// add local time zone offset
		// get UTC time in msec
		const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);

		// create new Date object for different timezone using supplied offset
		return new Date(utcTime + (3600000 * offsetHours));
	}

	// month is zero based
	export function getDaysInMonth(m, y) {
		switch (m) {
			case 1:
				return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28;
			case 8: case 3: case 5: case 10:
				return 30;
			default:
				return 31;
		}
	}

	// supports both DD-MM-YYYY and YYYY-MM-DD
	export function validateDateParts(date: string) {
		let year: number;
		let day: number;
		const dateParts = date.split("-");
		const month = +dateParts[1] - 1;
		if (dateParts[0].length === 4) {
			year = +dateParts[0];
			day = +dateParts[2];
		}
		else {
			year = +dateParts[2];
			day = +dateParts[0];
		}

		return month >= 0 && month < 12 && day > 0 && day <= getDaysInMonth(month, year);
	}

	export function convertKeyValuePairToMap<T>(raw: eXpress.core.KeyValuePair<T>[]): eXpress.core.Map<T> {
		const dict: eXpress.core.Map<T> = {};
		for (let i = 0; i < raw.length; i++) {
			dict[raw[i].Key] = raw[i].Value;
		}
		return dict;
	}

	export function getHeaderHeight(): number {
		let headerHeight = 0;
		$('.measureHeader').each(function () {
			headerHeight += $(this).height()!;
		});
		return headerHeight;
	}

	export function makeCssClass(raw: string): string {
		raw = raw.replace(/\./g, "-");
		raw = raw.replace(/_/g, "-");
		raw = raw.replace(/#/g, "");
		return raw.toLowerCase();
	}

	export function getQueryString(url?: string): string {
		url = url || window.location.href;
		const pos = url.indexOf("?");
		if (pos > -1) {
			return url.substring(pos + 1);
		} else {
			return url;
		}
	}

	export function getQueryStringParameters(url?: string): { [key: string]: string } {
		const queryString = eXpress.utils.getQueryString(url);
		// remove hash parameter and split querystring param
		const pairs = queryString.split('#')[0].split("&");
		const params: { [key: string]: string } = {};
		for (const pair of pairs) {
			const [key, value] = pair.split("=");
			params[key.toLowerCase()] = value !== undefined ? value : "true"; // Providing just the key means key=true
		}
		return params;
	}

	export function getQueryStringParameter(key: string, url?: string, required?: boolean): string;
	export function getQueryStringParameter(key: string, url?: string, required = false): string {
		const queryStringParam = eXpress.utils.getQueryStringParameters(url)[key.toLowerCase()];
		if (required && !queryStringParam) throw new Error(`No queryStringParam for Required key: ${key}`);
		return queryStringParam;
	}

	export function arrayToQuerystring(array: any[]) {
		let result = '';
		$.each(array, (index, value) => {
			if (result)
				result += ',';

			result += value.toString();
		});
		return result;
	}

	export function preventInvalidInput(textbox, regex, event, extraValidation?: (v: any) => boolean) {
		let key = event.keyCode || event.which;
		if (key !== 8 && key !== 9 && key !== 13 && key !== 16 && key !== 17 && key !== 18) {
			let newValue;
			key = String.fromCharCode(key);

			// warning! we will always validate the value of the entire textbox
			// maybe use bool to make this aditional check optional

			// if the old value - or part of the old value - was selected, this need to be stripped of the result (see else)
			// if the cursor is not at the end of the text, new char needs to be inserted at cursor position. (see else)
			if (textbox[0].selectionStart === textbox[0].selectionEnd && textbox[0].selectionEnd === textbox.val().length) {
				newValue = textbox.val() + key;
			}
			else {
				const val1 = textbox.val().substr(0, textbox[0].selectionStart);
				const val2 = textbox.val().substr(textbox[0].selectionEnd);

				// concat text in before selection start, the new char and the text after selection end.
				newValue = val1 + key + val2;
			}

			if (!regex.test(newValue) || (extraValidation && !extraValidation(newValue))) {
				textbox.stop();
				textbox.css('border', '1px solid red');
				setTimeout(function () { textbox.animate({ borderTopColor: '#c4c2d1', borderRightColor: '#c4c2d1', borderBottomColor: '#c4c2d1', borderLeftColor: '#c4c2d1' }, 500); }, 300);
				event.returnValue = false;
				if (event.preventDefault) event.preventDefault();
			}
		}
	}

	export interface IDetectLastResult<TOut> {
		isLastRequested: boolean;
		value: TOut;
	}

	/**
	 * Wrapper for Async functions that check if the result is from the last request
	 * This can be used to prevent race conditions for AJAX calls
	 */
	export class DetectLast<TIn, TOut> {

		private _execAsync: (args: TIn) => JQueryPromise<TOut>;
		private _lastId = 0;

		constructor(execAsync: (args: TIn) => JQueryPromise<TOut>) {
			this._execAsync = execAsync;
		}

		/**
		 * Execute async function and return object that also indicates if it is the result of the last request
		 */
		public execAsync(args: TIn): JQueryPromise<IDetectLastResult<TOut>> {
			const id = ++this._lastId;
			return this._execAsync(args).then((result: TOut) => ({
				isLastRequested: id === this._lastId,
				value: result
			}));
		}

		/**
		 * Mark executing calls as 'not last'
		 */
		public cancel(): void {
			++this._lastId;
		}

		/**
		 * return ID of the last executed async call
		 */
		public getLastId(): number {
			return this._lastId;
		}
	}

	export function formatString(s: string, ...args: string[]): string {
		let formatted = s;
		for (let i = 0; i < args.length; i++) {
			const regexp = new RegExp('\\{' + i + '\\}', 'gi');
			formatted = formatted.replace(regexp, args[i]);
		}
		return formatted;
	}

	export function isNumericValue(value: string): boolean {
		const regex = /^\d*$/;
		return regex.test(value);
	}

	export function reduceFontsizeToFit(itemEl: HTMLElement, minFontsize = 0) {
		function isOverflown(element) {
			return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
		}

		let fontSize = parseInt(getComputedStyle(itemEl).fontSize || "0", 10);
		for (let j = fontSize; j > minFontsize; j--) {
			const overflow = isOverflown(itemEl);
			if (overflow) {
				fontSize--;
				itemEl.style.fontSize = fontSize + "px";
			} else {
				break;
			}
		}
	}
}

// Polyfills

/* tslint:disable:interface-name */
interface Element {
	msMatchesSelector(selectors: string): boolean;
}

interface Array<T> {
	includes(searchElement: T): boolean;
}
/* tslint:enable:interface-name */

namespace eXpress {

	// Polyfill matches
	if (!Element.prototype.matches) {
		Element.prototype.matches = (Element.prototype as any).msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	// Polyfill closest
	if (!Element.prototype.closest) {
		Element.prototype.closest = function closestPolyfill(s: any) {
			const el = this;
			let ancestor = this;
			if (!document.documentElement.contains(el)) return null;
			do {
				if (ancestor.matches(s)) return ancestor;
				ancestor = ancestor.parentElement;
			} while (ancestor !== null);
			return null;
		};
	}

	// Polyfill insertAdjacentElement
	if (!Element.prototype.insertAdjacentElement) {
		Element.prototype.insertAdjacentElement = function (position, elem) {
			switch (position.toString().toUpperCase()) {
				case "BEFOREBEGIN":
					return this.parentNode.insertBefore(elem, this);
				case "AFTERBEGIN":
					return this.insertBefore(elem, this.firstChild);
				case "BEFOREEND":
					return this.appendChild(elem);
				case "AFTEREND":
					return this.parentNode.insertBefore(elem, this.nextSibling);
				default:
					throw new Error("Invalid element position `" + position + "`");
			}
		};
	}

	// Polyfill Array.includes()
	if (!Array.prototype.includes) {
		Object.defineProperty(Array.prototype, 'includes', {
			value: function (searchElement, fromIndex) {

				// 1. Let O be ? ToObject(this value).
				if (this == null) {
					throw new TypeError('"this" is null or not defined');
				}

				const o = Object(this);

				/* tslint:disable:no-bitwise */

				// 2. Let len be ? ToLength(? Get(O, "length")).
				const len = o.length >>> 0;

				// 3. If len is 0, return false.
				if (len === 0) {
					return false;
				}

				// 4. Let n be ? ToInteger(fromIndex).
				//    (If fromIndex is undefined, this step produces the value 0.)
				const n = fromIndex | 0;

				/* tslint:enable:no-bitwise */

				// 5. If n ≥ 0, then
				//  a. Let k be n.
				// 6. Else n < 0,
				//  a. Let k be len + n.
				//  b. If k < 0, let k be 0.
				let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

				// 7. Repeat, while k < len
				while (k < len) {
					// a. Let elementK be the result of ? Get(O, ! ToString(k)).
					// b. If SameValueZero(searchElement, elementK) is true, return true.
					// c. Increase k by 1.
					// NOTE: === provides the correct "SameValueZero" comparison needed here.
					if (o[k] === searchElement) {
						return true;
					}
					k++;
				}

				// 8. Return false
				return false;
			}
		});
	}

	// Polyfill ParentNode.append()
	(function (arr) {
		arr.forEach(function (item) {
			if (Object.hasOwnProperty.call(item, 'append')) {
				return;
			}
			Object.defineProperty(item, 'append', {
				configurable: true,
				enumerable: true,
				writable: true,
				value: function append(...args) {
					const docFrag = document.createDocumentFragment();

					args.forEach(function (argItem) {
						const isNode = argItem instanceof Node;
						docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
					});

					this.appendChild(docFrag);
				}
			});
		});
	})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
}

namespace eXpress.services {
	export declare let serviceDeps: IServiceDependencies;

	export class TokenExpiry {
		CountDownBarVisibleMinutes: number;
		TokenExpiryDate: string;
	}

	export enum DesignFilterCountName {
		Searchcolor = 3,
		Numberofphotos = 4,
		Price = 5,
		Productcode = 6,
		Predefinedproductcategory = 7,
		Orientation = 8
	}

	export interface IDesignFilterItemCount {
		Name: string;
		Count: number;
	}

	// start Storage service interfaces
	export interface IPhotos {
		readonly Photos: IPhoto[];
		readonly PageToken: string;
		readonly StoreType: StoreType;
	}

	export interface IPhoto {
		readonly Id: string;
		readonly Code: string;
		readonly AccountId: string;
		readonly FolderId: string;
		readonly Name: string;
		readonly Description: string;
		readonly OriginalFilename: string;
		readonly ThumbUrl: string;
		readonly MediumUrl: string;
		readonly HiresUrl: string;
		readonly DownloadUrl: string;
		readonly RelativeMediumUrl: string;
		readonly Width: number;
		readonly Height: number;
		readonly Rotate90: number;
		readonly FileSize: number;
		readonly DateTaken: string;
		readonly DateUploaded: string;
		readonly DateModified: string;
		readonly Hash: string;
	}

	export interface IPhotoStore {
		readonly StoreType: StoreType;
		readonly Name: string;
		readonly ConnectedUserName: string;
		readonly IsConnected: boolean;
		readonly LocatePhotosUrl: string;
		readonly ImportPhotosUrl: string;
		readonly UseExternalPhotoPicker: boolean;
		readonly ShowAlbum: boolean;
		readonly HasAlbumAccess: boolean;
		readonly PartnerLogoSvgUrl: string;
		readonly ShowTokenExpiry: boolean;
	}

	export enum StoreType {
		eXpress = 0,
		GooglePhotos = 2,
		Facebook = 3,
		Instagram = 4,
		SwissCom = 5,
		Local = 10
	}

	export enum SortOrder {
		Ascending = 0,
		Descending = 1
	}

	export enum PhotoSortBy {
		DateTaken = 0,
		DateUploaded = 1,
		DateModified = 2,
		Name = 3,
		OriginalFilename = 4
	}

	export enum FolderSortField {
		None = 0,
		Name = 1,
		DateCreated = 2,
		DateModified = 3,
		Owner = 4,
		InvitationDate = 5,
		LastFileAdded = 6,
		DateStorage = 7
	}

	export interface IPhotoFolders {
		readonly Folders: IPhotoFolder[];
		readonly PageToken: string;
		readonly StoreType: StoreType;
	}

	export interface ExternalPhotoPicker {
		readonly Id: string;
		readonly MediaItemsSet: boolean;
		readonly PickerUri: string;
		readonly PollingIntervalInSec: number;
		readonly ExpiresInSec: number;
	}

	export interface IFolderData {
		readonly id?: string;
		readonly fileCount: number;
		readonly name: string;
		readonly dateCreated: string;
	}

	export interface IPhotoFolder {
		readonly Id?: string;
		readonly FileCount: number;
		readonly Name: string;
		readonly ThumbUrl: string;
		readonly MediumUrl: string;
		readonly DateCreated: string;
		readonly Code?: string;
		readonly StoreType?: services.StoreType;
		readonly ThumbUrlRotation90?: number;
	}

	export interface IStorageId {
		readonly Id: string;
		readonly AccountId?: string;
	}
	// end Storage service interfaces

	// start Upload service interfaces

	export enum ImportStatus {
		Waiting = 0,
		Imported = 1,
		Failed = 2,
		NotFound = 3
	}

	export interface ICreateUploadSessionResult {
		readonly folderId: string;
		readonly id: string;
		readonly uploadUrl: string;
	}

	export interface ICheckImportStatusResultItem {
		readonly fileId: string;
		readonly info: string;
		readonly originalFileName: string;
		readonly status: ImportStatus;
	}

	// start design selection service

	// enums
	export enum OptionInDsp {
		Hide = 0,
		Icons = 1,
		Dropdown = 2
	}

	// Combines DesignVariantInListDSP && DesignVariantInopenDsp

	export enum DSPType {
		ListDSP = 0,
		OpenDSP = 1
	}

	export interface IIcon {
		IconSvg: string;
		IconColorCode: string;
		IconOverLayColorCode: string | null;
		Label: string;
		Orientation: Orientation | null;
	}

	export enum InDsp {
		Hide = 0,
		IconsSmall = 1,
		Icons = 2,
		IconsWithText = 3,
		Dropdown = 4
	}

	export enum Orientation {
		Undefined = 0,
		Horizontal = 1,
		Vertical = 2,
		Square = 3,
	}

	// end design selection service

	export function getToken(): JQueryPromise<string> {
		return ServiceBase.getTEXT('/apicore/authenticationapi/authenticationtoken').then(token => `ExpressForms ${token}`);
	}

	export class DownloadService extends ServiceBase {
		private token: string;
		protected url: string;
		private productCategoryGroup: string;

		constructor(token: string, apiHostUrl: string, productCategoryGroup: string) {
			super(apiHostUrl, "/mediastore/accounts");
			this.productCategoryGroup = productCategoryGroup;
			this.token = token;
		}

		public createDownloadSessionForPartnerPhotosAsync(partnerPhotoData: services.IPartnerPhotoData[], pointOfSaleId: string, accountId: string, language: string, flow: string): JQueryPromise<boolean> {
			const data = {
				pointOfSaleId,
				languageISO: language,
				downloads: partnerPhotoData.map(pd => {
					return { ...pd, ImageUrl: pd.StoreType === StoreType.GooglePhotos ? `${pd.ImageUrl}|${pd.Code}` : pd.ImageUrl };
				}),
				flow: flow,
				productCategoryGroup: this.productCategoryGroup
			};


			return ServiceBase.postJSON<boolean>(
				`${this.url}/${accountId}/download/sessions`,
				data,
				{
					'Authorization': this.token,
					'Content-type': 'application/json; charset=utf-8',
					'Cookies': document.cookie,
				}
			);
		}

		public downloadPartnerCheckStatusFilesAsync(fileIdsToCheck: string[], accountId: string): JQueryPromise<IDownloadStatusResult[]> {
			const data = fileIdsToCheck;

			return ServiceBase.postJSON<IDownloadStatusResult[]>(
				`${this.url}/${accountId}/download/sessions/status`,
				data,
				{
					'Authorization': this.token,
					'Content-type': 'application/json; charset=utf-8',
					'Cookies': document.cookie,
				});
		}
	}

	export type GetDesignsResult = any;

	export interface IGetDesignsResult {
		DesignCount: any;
		DesignFilterCount: any;
		Designs: IDesign[];
	}

	export interface IDesign {
		readonly Key?: string;
		readonly AlternativeColors?: IAlternativeColor[];
		readonly Color: string;
		readonly DisplayPrice: string;
		readonly ShowStar: boolean;
		readonly DisplayPricePerUnit: string;
		readonly DspName: string;
		readonly DspOverlayUrl: string;
		readonly New: boolean;
		readonly OpenDspOverlayUrl: string;
		readonly PackshotUrl: string;
		readonly PredefinedProductName: string;
		readonly Product: IProduct;
		readonly ProductAlternativesGroups: IProductAlternativesGroup[];
		readonly ProductCategory: IProductCategory;
		readonly ProductCategoryCode: string;
		readonly ProductCategoryGroupCode: string;
		readonly ProductCategoryGroups: string[];
		readonly ProductCode: string;
		readonly Pvc: string;
		readonly Top: boolean;
		readonly TemporaryUnavailable: boolean;
		readonly ProductVariantName: string;
		readonly Dimensions: string;
		readonly CanSwitchBackgroundInCreator: boolean;
		readonly HasSets: boolean;
		readonly SupportsPersonalData: boolean;
		readonly Debug: string;
	}

	export interface IConstellation {
		ConstellationName: string;
		ProductCode: string;
		ProductName: string;
		ShortName: string;
	}

	export interface IAlternativeColor {
		Color: string;
		DesignVariant?: IDesignVariant;
		PredefinedProductName: string;
		ProductCode: string;
	}

	export interface IDesignVariant {
		DesignVariantName: string;
		Icon: string;
		IconColorCode: string;
	}

	export interface IProduct {
		Name: string;
		ShortName: string;
		DesignVariantInListDSP: services.InDsp;
		DesignVariantInOpenDSP: services.InDsp;
	}

	export interface IProductAlternativesGroup {
		InCreator: any;
		InListDSP: services.InDsp;
		InOpenDSP: services.InDsp;
		ProductAlternatives: IProductAlternative[];
		Title: string;
	}

	export interface IProductAlternative {
		DesignWillBeLost: boolean;
		Icon: string;
		IconColorCode: string;
		IconOverlayColorCode: string;
		Orientation: string;
		PredefinedProductName: string;
		ProductCategoryCode: string;
		ProductCode: string;
		ProductVariantCode: string;
		Title: string;
	}

	export interface IProductCategory {
		Name: string;
		ShortName: string;
		ShowMeasurements: boolean;
	}

	export interface IDesignDetail {
		AttributeDetails?: IDesignAttributeDetails;
		DisableOverlays: boolean;
		EditorStartLink: string;
		ProductOptionGroups?: IDesignProductOptionGroup[];
		ProductPreviewImageCount: number;
		ProductPreviewImageUrls: string[];
		QuantityBreakPriceDetails: IDesignQuantityBreakPriceDetails;
		ShipmentDetails: { [key: string]: any };
		USPs: string;
		VariablePriceDetails: any | null;
		PromotionDetails?: any;
		ProductDimensions: string;
	}

	export interface IDesignAttributeDetails {
		Name: string;
		Values?: IDesignAttributeDetailsValue[];
	}

	export interface IDesignAttributeDetailsValue {
		Code: string;
		// whether this option is the default
		Default: boolean;
		Name: string;
		QuantityBreakPriceDetails: any | null;
	}

	export interface IDesignQuantityBreakPriceDetails {
		DefaultQuantityBreaks: number;
		QuantityBreaks: IDesignQuantityBreak[];
	}

	export interface IDesignQuantityBreak {
		Break: number;
		Price: number;
	}

	export interface IDesignProductOptionGroup {
		Name: string;
		Code: string;
		InDsp: any;
		InCreator: any;
		InOptionPage: any;
		Description: string;
		ProductOptions: IDesignProductOption[] | null;
		SiblingDataOptionUSPs?: any;
		SiblingDataPageTitle?: string;
		Specification?: any;
		Title: string;
	}

	export interface IDesignProductOption {
		Code: string;
		DefaultProductOption: boolean;
		OpenDspOverlayUrl?: string;
		DspOverlayUrl?: string;
		AlternativeOptionGroup: string;
		Name: string;
		Price: number;
		VarPrice: number;
		ShortName: string;
		Specification?: any;
		VarAmount: number;
	}

	export interface IProductCategoryDetails {
		ShortName: string;
		Name: string;
		ShortTitle: string;
		Title: string;
		ProductCategoryCode: string;
		ImageUrl: string;
		DisplayPrice: string;
		LinkToProductCategoryPage: string;
		EyeCatcher: string;
	}

	export interface IGetProductCategoriesResult {
		ProductCategories: IProductCategoryDetails[];
		TotalNumberOfResults: number;
	}

	export class SelectionPageService extends ServiceBase {

		protected url: string;

		constructor(apiHostUrl: string) {
			super(apiHostUrl, "SelectionPageService.svc/json/");
		}

		public getDesignsAsync(pointOfSaleId: string,
			language: string,
			mainProductCategoryGroupCode: string | undefined,
			productCode: string[],
			orientation: string | undefined,
			predefinedProductCategory: string[],
			searchColor: string[],
			imageCount: number[],
			price: number[],
			pageNumber: number,
			pageSize: number,
			options: string[],
			optionGroup: string,
			ownDesign: boolean,
			sortMethod: string | undefined,
			designGroup: string | undefined,
			gender: string | undefined,
			showDebug: boolean
		): JQueryPromise<GetDesignsResult> {
			const args = {
				pointOfSaleId: pointOfSaleId,
				language: language,
				mainProductCategoryGroupCode: mainProductCategoryGroupCode,
				productCode: productCode,
				orientation,
				predefinedProductCategory: predefinedProductCategory,
				searchColor: searchColor,
				imageCount: imageCount,
				price: price,
				pageNumber: pageNumber,
				pageSize: pageSize,
				options: options,
				optionGroup,
				ownDesign: ownDesign,
				sortMethod: sortMethod,
				designGroup: designGroup,
				gender: gender,
				showDebug: showDebug
			};

			return ServiceBase.getJSON<IGetDesignsResult>(this.url + 'GetDesigns', args)
				.then(res => deserialization.getDesignsResultConvert(res));
		}

		public getProductCategories(pointOfSaleId: string,
			language: string,
			pageNumber: number,
			pageSize: number,
			productCategories: string[],
			tagValues: string[],
			sortMethod?: string,
			theme?: string
		): JQueryPromise<services.IGetProductCategoriesResult> {
			const args = {
				pointOfSaleId: pointOfSaleId,
				language: language,
				pageNumber: pageNumber,
				pageSize: pageSize,
				productCategories: productCategories,
				tagValues: tagValues,
				sortMethod: sortMethod,
				theme: theme
			};

			return ServiceBase.getJSON(this.url + 'GetProductCategories', args);
		}

		public getDesign(pointOfSaleId: string,
			language: string,
			predefinedProductName: string,
			productCode: string,
			options: string[],
			optionGroup: string): JQueryPromise<any> {
			const args = {
				pointOfSaleId: pointOfSaleId,
				language: language,
				predefinedProductName: predefinedProductName,
				productCode: productCode,
				options: options,
				optionGroup
			};

			return ServiceBase.getJSON(this.url + 'GetDesign', args)
				.then(res => { return deserialization.designConvert(res as services.IDesign); });
		}

		public getDesignDetail(pointOfSaleId: string,
			language: string,
			predefinedProductName: string,
			productCode: string,
			theme: string | undefined,
			options: string | undefined
		): JQueryPromise<core.IDesignDetail> {
			const args = {
				pointOfSaleId,
				language,
				predefinedProductName,
				productCode,
				theme,
				options
			};

			return ServiceBase.getJSON(this.url + 'GetDesignDetail', args)
				.then(res => { return deserialization.designDetailConvert(res as services.IDesignDetail); });
		}

		public getConstellationsAsync(pointOfSaleId: string,
			language: string,
			productCode: string,
			predefinedProductName: string): JQueryPromise<core.IConstellation[]> {
			const args = {
				pointOfSaleId: pointOfSaleId,
				language: language,
				productCode: productCode,
				predefinedProductName: predefinedProductName
			};

			return ServiceBase.getJSON<services.IConstellation[]>(this.url + 'GetConstellations', args)
				.then(res => res.map(c => deserialization.designConstellationConvert(c)));
		}

		public GetDesignFilterCount(
			pointOfSaleId: string,
			language: string,
			designFilterCountName: DesignFilterCountName,
			mainProductCategoryGroupCode?: string,
			productCodes?: string[],
			orientation?: string,
			predefinedProductCategories?: string[],
			searchColors?: string[],
			imageCounts?: number[],
			prices?: number[],
			gender?: string,
			ownDesign?: boolean): JQueryPromise<IDesignFilterItemCount[]> {

			const args = {
				pointOfSaleId,
				language,
				designFilterCountName,
				mainProductCategoryGroupCode: [mainProductCategoryGroupCode],
				productCode: productCodes,
				orientation,
				predefinedProductCategory: predefinedProductCategories,
				searchColor: searchColors,
				imageCount: imageCounts,
				price: prices,
				ownDesign,
				designGroup: null,
				gender
			};

			return ServiceBase.getJSON(this.url + 'GetDesignFilterCount', args);
		}

		public getQuantityBreakOnlyByMaASync(pointOfSaleId: string,
			language: string,
			productCode: string): JQueryPromise<boolean> {

			const args = {
				pointOfSaleId,
				language,
				productCode
			};

			return ServiceBase.getJSON(this.url + 'QuantityBreakOnlyByMA', args);
		}
	}

	export class StorageService extends ServiceBase {
		protected url: string;

		constructor(apiHostUrl: string) {
			super(apiHostUrl, "StorageService.svc/json/");
		}

		public getPhotoStoresAsync(
			pointOfSaleId: string,
			language: string,
			skipIsConnectedCheck = false,
			skipPhotoDownload = false,
			skipSignleSignOn = false,
			maxNumberOfRetries = 0,
			retry = 0
		): JQueryPromise<core.IPhotoStore[]> {
			const args = {
				pointOfSaleId,
				language,
				maxNumberOfRetries,
				retry,
				skipIsConnectedCheck,
				skipPhotoDownload,
				skipSignleSignOn
			};
			return ServiceBase.getJSON<{ GetPhotoStoresResult: IPhotoStore[] }>(this.url + 'GetPhotoStores', args)
				.then(res => res.GetPhotoStoresResult.map(store => deserialization.photoStoreConvert(store, this)));
		}

		public getFolderListWithThumbAsync(
			accountId: string,
			pointOfSaleId: string,
			folderId: string
		): JQueryPromise<eXpress.core.SmartphotoFolder[]> {
			const args = {
				accountId,
				pointOfSaleId,
				folderId,
				sortField: FolderSortField.DateCreated,
				sortOrder: SortOrder.Descending
			};
			return ServiceBase.getJSON<{ GetFolderListWithThumbResult: IPhotoFolder[] }>(this.url + 'GetFolderListWithThumb', args)
				.then(res => res.GetFolderListWithThumbResult.map((folder) => eXpress.deserialization.photoFolderConvert(folder, this)));
		}

		public getPhotosByFolderAsync(
			pointOfSaleId: string,
			accountId: string,
			folderId: string,
			page: number,
			pageSize: number,
			sortBy: PhotoSortBy,
			sortOrder: SortOrder,
			readOnly: boolean): JQueryPromise<core.Photo[]> {

			const args = {
				pointOfSaleId,
				accountId,
				folderId,
				page,
				pageSize,
				sortBy,
				sortOrder,
				readOnly
			};
			return ServiceBase.getJSON<{ GetPhotosByFolderResult: eXpress.services.IPhoto[] }>(this.url + "GetPhotosByFolder", args)
				.then(res => {
					if (!res) return [];

					return res.GetPhotosByFolderResult.map((photo) => eXpress.deserialization.photoConvert(photo));
				});
		}

		public getPhotosAsync(
			pointOfSaleId: string,
			accountId: string,
			folderId: string,
			ids: string[],
			useDeselected = false,
			isSelectAllActive = false): JQueryPromise<core.Photo[]> {

			const args = {
				pointOfSaleId,
				accountId,
				folderId,
				ids,
				useDeselected,
				isSelectAllActive
			};
			return ServiceBase.postJSON<{ GetExpressPhotosResult: eXpress.services.IPhoto[] }>(this.url + "GetExpressPhotos", args)
				.then((res) => {
					return res.GetExpressPhotosResult.map((photo) => eXpress.deserialization.photoConvert(photo));
				});
		}

		public getPhotosByFoldersAsync(
			pointOfSaleId: string,
			accountId: string,
			folderIds: string[],
			useDeselected = false,
			limit = -1): JQueryPromise<eXpress.core.ISmartphotoPhoto[]> {

			const args = {
				pointOfSaleId,
				accountId,
				folderIds,
				useDeselected,
				limit
			};
			return ServiceBase.postJSON<{ GetPhotosByFoldersResult: eXpress.services.IPhoto[] }>(this.url + "GetPhotosByFolders", args)
				.then((res) => {
					return res.GetPhotosByFoldersResult.map((photo) => eXpress.deserialization.photoConvert(photo));
				});
		}

		public deleteMediaStorePartnerAccountMemberAsync(
			storeCode: core.StoreCode,
			accountId: string,
			pointOfSaleId: string
		): JQueryPromise<boolean> {
			const args = {
				mediaStorePartnerType: serialization.convertStoreCodeToStoreType(storeCode),
				accountId,
				pointOfSaleId
			};

			return ServiceBase.getJSON<{ DeleteMediaStorePartnerAccountMemberResult: boolean }>(this.url + 'DeleteMediaStorePartnerAccountMember', args).then(res => res.DeleteMediaStorePartnerAccountMemberResult);
		}

		public deleteFilesAsync(
			ids: string[],
			pointOfSaleId: string
		): JQueryPromise<void> {
			const args = {
				ids: eXpress.serialization.convertPhotoIdToStorageIdWithoutAccountId(ids),
				pointOfSaleId
			};
			return ServiceBase.postJSON<void>(this.url + 'DeleteFiles', args);
		}

		public deleteAllFilesInFolderAsync(
			accountId: string,
			folderId: string
		): JQueryPromise<{}> {
			const args = {
				accountId,
				folderId
			};
			return ServiceBase.postJSON<{}>(this.url + 'DeleteAllFilesInFolder', args);
		}

		public getFileIdsInFolderAsync(
			accountId: string,
			folderId: string
		): JQueryPromise<string[]> {
			const args = {
				accountId,
				folderId
			};
			return ServiceBase.getJSON<{ GetFileIdsInFolderResult: string[] }>(this.url + 'GetFileIdsInFolder', args)
				.then(res => res.GetFileIdsInFolderResult);
		}

		public getFolderWithCountAsync(
			accountId: string,
			folderId: string
		): JQueryPromise<eXpress.core.SmartphotoFolder> {
			const args = {
				accountId,
				folderId
			};
			return ServiceBase.getJSON<{ GetFolderWithCountResult: eXpress.services.IPhotoFolder }>(this.url + 'GetFolderWithCount', args)
				.then(res => eXpress.deserialization.photoFolderConvert(res!.GetFolderWithCountResult, this));
		}

		public getTokenExpiry(
			storeCode: core.StoreCode,
			accountId: string,
			pointOfSaleId: string
		): JQueryPromise<eXpress.core.TokenExpiry> {
			const args = {
				accountId,
				pointOfSaleId,
				mediaStorePartnerType: serialization.convertStoreCodeToStoreType(storeCode)
			};
			return ServiceBase.postJSON<{ GetTokenExpiryResult: eXpress.services.TokenExpiry }>(this.url + 'GetTokenExpiry', args)
				.then(res => eXpress.deserialization.TokenExpiryConvert(res.GetTokenExpiryResult));
		}

		public getPartnerAlbumsAsync(
			storeCode: core.StoreCode,
			accountId: string,
			pointOfSaleId: string,
			page: number,
			pageSize: number,
			pageToken: string
		): JQueryPromise<eXpress.core.partners.PartnerFolder[] | null> {
			const storeType = serialization.convertStoreCodeToStoreType(storeCode);
			const args = {
				accountId,
				pointOfSaleId,
				mediaStorePartnerType: serialization.convertStoreCodeToStoreType(storeCode),
				page,
				pageSize,
				pageToken
			};
			return ServiceBase.postJSON<{ GetMediaStorePartnerAlbumsResult: eXpress.services.IPhotoFolders }>(this.url + 'GetMediaStorePartnerAlbums', args)
				.then(res => res && res.GetMediaStorePartnerAlbumsResult.Folders
					.map(f => eXpress.deserialization.partnerFolderConvert(f, res.GetMediaStorePartnerAlbumsResult.StoreType, res.GetMediaStorePartnerAlbumsResult.PageToken, this)));
		}

		public getPartnerPhotosAsync(pointOfSaleId: string,
			accountId: string,
			store: StoreType,
			folderCode: string,
			selectedIds: string[],
			isSelectAllActive = false,
			useDeselected = false
		): JQueryPromise<eXpress.core.partners.PartnerPhoto[]> {
			const args = { pointOfSaleId, accountId, selectedIds, mediaStorePartnerType: store, folderCode, isSelectAllActive, useDeselected };

			return ServiceBase.postJSON<{ GetMediaStorePartnerPhotosResult: eXpress.services.IPhotos }>(this.url + "GetMediaStorePartnerPhotos", args)
				.then(res => res && res.GetMediaStorePartnerPhotosResult.Photos
					.map(photo => eXpress.deserialization.partnerPhotoConvert(photo, res.GetMediaStorePartnerPhotosResult.StoreType, res.GetMediaStorePartnerPhotosResult.PageToken)));
		}

		public getPartnerPhotosInFolderAsync(
			folderCode: string,
			storeType: StoreType,
			accountId: string,
			pointOfSaleId: string,
			page?: number,
			pageSize?: number,
			pageToken?: string

		): JQueryPromise<eXpress.core.partners.PartnerPhoto[]> {
			const args = {
				folderCode,
				accountId,
				pointOfSaleId,
				mediaStorePartnerType: storeType,
				page,
				pageSize,
				pageToken
			};

			return ServiceBase.postJSON<{ GetMediaStorePartnerPhotosOfFolderResult: eXpress.services.IPhotos }>(this.url + "GetMediaStorePartnerPhotosOfFolder", args)
				.then(res => res && res.GetMediaStorePartnerPhotosOfFolderResult.Photos
					.map(photo => eXpress.deserialization.partnerPhotoConvert(photo, res.GetMediaStorePartnerPhotosOfFolderResult.StoreType, res.GetMediaStorePartnerPhotosOfFolderResult.PageToken)));
		}

		public renameFolderAsync(
			accountId: string,
			folderId: string,
			name: string
		): JQueryPromise<{}> {
			const args = {
				folderId: {
					Id: folderId,
					AccountId: accountId
				},
				newName: name
			};
			return ServiceBase.postJSON<{}>(this.url + 'RenameFolder', args);
		}

		public createFolderAsync(
			accountId: string,
			name: string
		): JQueryPromise<core.SmartphotoFolder> {
			const args = {
				accountId,
				name,
				description: ""
			};
			return ServiceBase.postJSON<{ CreateFolderResult: services.IPhotoFolder }>(this.url + 'CreateFolder', args)
				.then(f => eXpress.deserialization.photoFolderConvert(f!.CreateFolderResult, this));
		}

		public deleteFoldersAsync(
			accountId: string,
			folderIds: string[]
		): JQueryPromise<{}> {
			const args = {
				folderIds: eXpress.serialization.convertPhotoIdToStorageId(folderIds, accountId)
			};
			return ServiceBase.postJSON<{}>(this.url + 'DeleteFolders', args);
		}

		public moveFilesAsync(accountId: string, oldFolderId: string, newFolderId: string, ids: string[]): JQueryPromise<{}> {
			const args = {
				accountId,
				oldFolderId,
				newFolderId,
				ids: eXpress.serialization.convertPhotoIdToStorageId(ids, accountId)
			};

			return ServiceBase.postJSON<{}>(this.url + 'MoveFiles', args);
		}

		public moveAllFilesInFolderAsync(accountId: string, oldFolderId: string, newFolderId: string): JQueryPromise<{}> {
			const args = {
				accountId,
				oldFolderId,
				newFolderId
			};
			return ServiceBase.postJSON<{}>(this.url + 'MoveAllFilesInFolder', args);
		}

		public rotatePhotosAsync(
			accountId: string,
			rotation: number,
			...ids: string[]
		): JQueryPromise<{}> {
			const args = {
				accountId,
				ids: eXpress.serialization.convertPhotoIdToStorageId(ids, accountId),
				rotation: ((rotation || 0) + 360) % 360
			};
			return ServiceBase.postJSON<{}>(this.url + 'RotatePhotos', args);
		}

//#region externalPhotoPicker
		public createExternalPhotoPicker(storeTypeId: number, accountId: string, pointOfSaleId: string): JQueryPromise<ExternalPhotoPicker> {
			const args = {
				mediaStorePartnerType: storeTypeId,
				accountId,
				pointOfSaleId
			};

			return ServiceBase.getJSON<{ CreateExternalPhotoPickerResult: ExternalPhotoPicker }>(this.url + 'CreateExternalPhotoPicker', args)
				.then(res => res.CreateExternalPhotoPickerResult);
		}

		public getExternalPhotoPicker(storeTypeId: number, accountId: string, pointOfSaleId: string, sessionId: string): JQueryPromise<ExternalPhotoPicker> {
			const args = {
				mediaStorePartnerType: storeTypeId,
				accountId,
				pointOfSaleId,
				sessionId
			};

			return ServiceBase.getJSON<{ GetExternalPhotoPickerResult: ExternalPhotoPicker }>(this.url + 'GetExternalPhotoPicker', args)
				.then(res => res.GetExternalPhotoPickerResult);
		}

		public getExternalPhotoPickerPhotos(storeTypeId: number, accountId: string, pointOfSaleId: string, sessionId: string): JQueryPromise<eXpress.core.partners.PartnerPhoto[]> {
			const args = {
				mediaStorePartnerType: storeTypeId,
				accountId,
				pointOfSaleId,
				sessionId
			};

			return ServiceBase.getJSON<{ GetExternalPhotoPickerPhotosResult: eXpress.services.IPhotos }>(this.url + "GetExternalPhotoPickerPhotos", args)
				.then(res => res && res.GetExternalPhotoPickerPhotosResult.Photos
					.map(photo => eXpress.deserialization.partnerPhotoConvert(photo, res.GetExternalPhotoPickerPhotosResult.StoreType, res.GetExternalPhotoPickerPhotosResult.PageToken)));
		}

		public deleteExternalPhotoPicker(storeTypeId: number, accountId: string, pointOfSaleId: string, sessionId: string): JQueryPromise<boolean> {
			const args = {
				mediaStorePartnerType: storeTypeId,
				accountId,
				pointOfSaleId,
				sessionId
			};

			return ServiceBase.postJSON<{}>(this.url + 'DeleteExternalPhotoPicker', args)
				.then((res: { DeleteExternalPhotoPickerResult: boolean }) => res.DeleteExternalPhotoPickerResult);
		}
	//#endregion
	}

	export class UploadService extends ServiceBase {
		protected url: string;
		private hostUrl: string;
		private token: string;
		constructor(apiHostUrl: string, ecomUrl: string) {
			super(ecomUrl, "/mediastore/accounts");
			this.hostUrl = apiHostUrl; // old wcf service
		}

		public setToken = async ()=> {
			if (!this.token)
				this.token = await services.getToken();
		};

		public createUploadSessionAsync(pointOfSaleId: string, accountId: string, folderId: string, flow: string, uploadTechnology: string): JQueryPromise<ICreateUploadSessionResult> {
			const args = {
				pointOfSaleId,
				folderId,
				flow,
				uploadTechnology
			};

			return ServiceBase.postJSON<ICreateUploadSessionResult>(`${this.url}/${accountId}/upload/session`,
				args,
				{
					'Authorization': this.token,
					'Content-type': 'application/json; charset=utf-8',
					'Cookies': document.cookie,
				});
		}

		public getUploadFolderForProductCategoryAsync(accountId: string, productCategory: string): JQueryPromise<core.IPhotoFolder> {
			return ServiceBase.postJSON<services.IFolderData>(`${this.url}/${accountId}/upload/session/folder`,
			{ParentProductCategory: productCategory},
			{
				'Authorization': this.token,
				'Content-type': 'application/json; charset=utf-8',
				'Cookies': document.cookie,
			})
			.then(res => deserialization.photoFolderDataConvert(res, new StorageService(this.hostUrl)));
		}

		public checkImportStatusForSessionAsync(accountId: string, uploadSessionId: string): JQueryPromise<ICheckImportStatusResultItem[]> {
			return ServiceBase.getJSON<ICheckImportStatusResultItem[]>(`${this.url}/${accountId}/upload/session/status?sessionId=${uploadSessionId}`,
				null,
				{
					'Authorization': this.token,
					'Content-type': 'application/json; charset=utf-8',
					'Cookies': document.cookie,
				});
		}
	}

	export class Services {
		public apiHostUrl: string;
		protected pointOfSaleId: string;
		protected language: string;
		public selectionPage: SelectionPageService;
		public storageService: StorageService;
		public uploadService: UploadService;

		constructor(deps: IServiceDependencies) {
			// Our services expect the apiHostUrl to end with a forward slash.
			this.apiHostUrl = deps.apiHostUrl;
			this.pointOfSaleId = utils.required(deps.pointOfSaleId, "no pointOfSaleID in AppContext");
			this.language = utils.required(deps.languageCode, "no LanguageCode in AppContext");
			this.selectionPage = new SelectionPageService(this.apiHostUrl);
			this.storageService = new StorageService(this.apiHostUrl);

				this.uploadService = new UploadService(this.apiHostUrl, window.context.ecomApiUrl);
		}
	}
}

namespace eXpress.services.bulkeditor {
	export interface IProduct {
		Code: string;
		Attributes: eXpress.core.KeyValuePair<string>[];
		AttributesDict: eXpress.core.Map<string>;
		Options: eXpress.core.KeyValuePair<string[]>[];
		OptionsDict: eXpress.core.Map<string[]>;
	}

	export interface ISimpleCartItem {
		Products: ICartItemProduct[];
	}

	export interface ICartItem {
		CreatedForced: string | null;
		DateModifiedParent: string | null;
		DatePictureTaken: string | null;
		FileSize: number;
		Id: string;
		Manipulations: IManipulations;
		OriginalFileName: string;
		OriginalHeight: number;
		OriginalWidth: number;
		PhotoId: string;
		Products: ICartItemProduct[];
		ApplyAllFailed: boolean;
		PhotoCounter: number;
		ThumbUrl: string;
		MediumUrl: string;
	}

	export interface ICartItemProduct {
		ProductCode: string;
		Quantity: number;
		Border: string | null;
		ColorEffect: string | null;
		Paper: string | null;
		CartItemId: string;
	}

	export interface IManipulations {
		ColorEffect: string | null;
		Height: number;
		Left: number;
		Rotate90: number;
		Top: number;
		Width: number;
	}

	export interface IBulkEditorGetAllProductsResult {
		Products: IProduct[];
		Translations: eXpress.core.KeyValuePair<string>[];
		BulkSequenceShapes: string[];
	}
}

namespace eXpress.core.bulkeditor {
	export enum WhiteBorderType {
		None = 0,
		Normal3mm = 1,
		Retro = 2
	}

	export function fillOneItemUrl(item: CartItem, ecomApiUrl: string, whiteBorderType = WhiteBorderType.None, forCropping = false, doClippingAndRotationOnClient = true, size = 0): string {
		let url = `${ecomApiUrl}/mediastore/accounts/${GetCookie("accid")}/photos/${item.photoId}/transforms?streamName=medium`;

		if (size > 0)
			url += '&size=' + size;

		if (!forCropping && !doClippingAndRotationOnClient && whiteBorderType === WhiteBorderType.Normal3mm)
			url += '&wbm=15,15,15,15';
		else if (!forCropping && !doClippingAndRotationOnClient && whiteBorderType === WhiteBorderType.Retro)
			url += '&wbm=15,15,60,15';
		if (!forCropping && !doClippingAndRotationOnClient)
			url += '&crop=' + item.manipulations.left + ',' + item.manipulations.top + ',' + item.manipulations.width + ',' + item.manipulations.height;
		if (item.manipulations.colorEffect)
			url += '&ce=' + item.manipulations.colorEffect;
		if (!doClippingAndRotationOnClient)
			url += '&rot90=' + item.manipulations.rotate90;

		url += '&upd=' + item.dateModifiedParent.getTime();

		return url;
	}
}
